<template>
    <div>
        <div class="conteudo backg-logado">
            <v-app-bar app height="96" absolute hide-on-scroll class="xs-100">
                <div class="btn-group d-flex align-items-center justify-content-between">
                    <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up branco"></v-app-bar-nav-icon>
                    <v-img alt="Editora do Brasil" class="shrink" contain src="@/assets/logo-white.png"
                        transition="scale-transition" width="120" />
                    <v-toolbar-title class="txt-titulo hidden-md-and-up">
                        <h2>Consultor<br>Digital</h2>
                    </v-toolbar-title>
                    <v-toolbar-title class="txt-titulo hidden-sm-and-down">
                        <h2>Consultor Digital</h2>
                    </v-toolbar-title>
                </div>

                <v-row class="busca">
                    <v-col cols="12">
                        <div class="d-flex justify-center">
                            <div class="campo-de-busca">
                                <div class="autosuggest-container">
                                    <vue-autosuggest
                                        ref="autosuggest"
                                        :key="autosuggestKey"
                                        v-model="query"
                                        :suggestions="filteredOptions"
                                        @focus="focusMe"
                                        @input="onInputChange"
                                        @selected="onSelected"
                                        :get-suggestion-value="getSuggestionValue"
                                        :input-props="{
                                            id: 'autosuggest__input',
                                            placeholder: 'Digite o nome do livro',
                                            onKeydown: onKeyDown
                                        }">
                                        <div slot-scope="{suggestion}">
                                            <div v-if="suggestion.item.tipo === 'colecao-grupo'" class="autosuggest-dicas-grupo">
                                                <span class="autosuggest-dicas-label">Você quer buscar:</span>
                                                <span v-for="dica in suggestion.item.dicas" :key="dica" class="autosuggest-dica-chip" @mousedown.prevent.stop="usarDicaColecao(dica)">
                                                    {{ dica }}
                                                </span>
                                            </div>
                                            <div v-else class="autosuggest-item">
                                                <img class="autosuggest-capa" :src="suggestion.item.imagem" />
                                                <div class="autosuggest-info">
                                                    <span class="autosuggest-titulo" v-html="highlightTexto(suggestion.item.titulo)"></span>
                                                    <span class="autosuggest-segmento">{{ suggestion.item.seguimento }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </vue-autosuggest>
                                    <v-btn @click="pesquisarNome()" icon class="mt-1">
                                        <v-icon href color="primary">search</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                <v-toolbar-items class="hidden-sm-and-down box-logado">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="primary--text" text v-bind="attrs" v-on="on">
                                <v-img src="@/assets/icon-user.png" /> Olá, <span v-text="userName"></span> <v-icon right>keyboard_arrow_down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-title>
                                    <v-btn @click="sair()" text block class="primary--text">Sair</v-btn>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar-items>
            </v-app-bar>

            <v-navigation-drawer class="menu-header-mobile" v-model="drawer" absolute temporary>
                <v-list nav dense>
                    <v-list-item-group active-class="primary--text text--accent-4">
                        <v-list-item two-line :disabled="isMobile">
                            <v-list-item-avatar>
                                <v-icon color="primary">person</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title><span v-text="userName"></span></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mb-4"></v-divider>
                        <v-list-item>
                            <v-list-item-icon><v-icon color="primary">mail</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <a class="primary--text" href="//editoradobrasil.com.br/fale-conosco" target="_blank">Contato</a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-4 mb-4"></v-divider>
                        <v-list-item>
                            <v-list-item-icon><v-icon color="primary">logout</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <a class="primary--text" @click="sair()" href="#">Sair</a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
        </div>

        <vue-headful title="Catálogo Digital | Editora do Brasil" description="Catálogo Digital da Editora do Brasil" />

        <section>
            <v-container fluid class="pt-8 pb-16 box-conteudo-lag">
                <v-row class="hidden-md-and-up">
                    <v-col cols="12">
                        <v-btn class="btn-filtrar" text @click="sheet = !sheet">
                            <v-icon>filter_list</v-icon>Filtrar
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- Filtro Mobile -->
                <v-bottom-sheet v-model="sheet" inset class="hidden-md-and-up">
                    <v-sheet class="text-center" style="overflow-y: auto">
                        <v-card width="100%" outlined class="filtro filtro-mobile">
                            <v-list-item class="title">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Filtros
                                        <v-btn v-if="mercadosSelecionados.length > 0" icon small text @click="limparArvoreFiltros" title="Limpar filtros">
                                            <v-icon small>refresh</v-icon>
                                        </v-btn>
                                        <v-btn icon class="btn-fechar-filtro" text @click="sheet = !sheet">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <!-- Nível 1 - Mercado (cada opção pode expandir sua própria ramificação) -->
                            <div v-for="opcao in opcoesMercado" :key="opcao.valor" class="filtro-mercado-item">
                                <div class="filtro-checkbox-row filtro-nivel-1" @click="selecionarMercado(opcao.valor)">
                                    <v-checkbox
                                        :input-value="mercadosSelecionados.includes(opcao.valor)"
                                        @click.stop="selecionarMercado(opcao.valor)"
                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                    <span :class="{ 'filtro-label-ativo': mercadosSelecionados.includes(opcao.valor) }">{{ opcao.label }}</span>
                                </div>

                                <!-- Nível 2 - Categoria (abre dentro do Mercado selecionado) -->
                                <div v-if="mercadosSelecionados.includes(opcao.valor)" class="filtro-nivel-bloco">
                                    <div v-for="cat in categoriasDisponiveis" :key="cat">
                                        <div class="filtro-checkbox-row filtro-nivel-2" @click="selecionarCategoria(cat, opcao.valor)">
                                            <v-checkbox
                                                v-model="categoriasSelecionadas"
                                                :value="cat"
                                                @click.stop
                                                @change="resetFiltrosAbaixoCategoria(cat, opcao.valor)"
                                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                            <span :class="{ 'filtro-label-ativo': categoriasSelecionadas.includes(cat) }">{{ cat }}</span>
                                        </div>

                                        <!-- Nível 3 - Segmento (abre dentro da Categoria selecionada) -->
                                        <div v-if="categoriasSelecionadas.includes(cat)" class="filtro-nivel-bloco">
                                            <div v-if="cat === 'Literatura'">
                                                <!-- Grupo: Ano / Série -->                                                
                                                <div v-for="grupo in literaturaAnoSerieGrupos()" :key="grupo.titulo">
                                                    <div class="filtro-nivel-3 filtro-segmento-titulo filtro-segmento-titulo-clicavel" @click="toggleGrupoExpandido('lit-seg|' + grupo.titulo + '|' + opcao.valor)">
                                                        <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-seg|' + grupo.titulo + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                        {{ grupo.titulo }}
                                                    </div>
                                                    <div v-if="grupoExpandido('lit-seg|' + grupo.titulo + '|' + opcao.valor)" class="filtro-nivel-bloco">
                                                        <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in grupo.itens" :key="item.chave" @click="selecionarLitAnoSerie(item.chave)">
                                                            <v-checkbox v-model="litAnoSerieSelecionados" :value="item.chave" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                            <span :class="{ 'filtro-label-ativo': litAnoSerieSelecionados.includes(item.chave) }">{{ item.label }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Grupo: Autor / Ilustrador 1-->
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-autor|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-autor|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Autor / Ilustrador
                                                </div>
                                                <div v-if="grupoExpandido('lit-autor|' + opcao.valor)" class="filtro-nivel-bloco busca-autor" style="padding-bottom:10px;">
                                                    <v-autocomplete
                                                        v-model="autoresAdicionados"
                                                        :items="autoresLiteraturaDisponiveis()"
                                                        multiple
                                                        dense
                                                        hide-details
                                                        clearable
                                                        placeholder="Buscar autor"
                                                        class="filtro-autocomplete filtro-nivel-4"
                                                    ></v-autocomplete>
                                                </div>

                                                <!-- Grupo: Coleções -->
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-colecoes|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-colecoes|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Coleções
                                                </div>
                                                <div v-if="grupoExpandido('lit-colecoes|' + opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="colecao in colecoesLiteraturaDisponiveis()" :key="colecao" @click="filterColecao(colecao)">
                                                        <v-checkbox :input-value="colecoesAdicionadas.includes(colecao)" @click.stop="filterColecao(colecao)" color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': colecoesAdicionadas.includes(colecao) }">{{ colecao }}</span>
                                                    </div>
                                                </div>

                                                <!-- Grupo: Conteúdos disciplinares -->
                                                <!-- 29/07: some em Mercado Privado (pedido pontual). 29/07 (2ª vez): some também em
                                                     Mercado Público - fica escondido nos dois mercados agora. -->
                                                <div v-if="false" class="filtro-titulo-grupo">Conteúdos disciplinares</div>
                                                <div v-if="false" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in Object.keys(mapaConteudosLiteratura()).sort((a, b) => a.localeCompare(b, 'pt-BR'))" :key="item" @click="selecionarLitConteudo(item)">
                                                        <v-checkbox v-model="litConteudosSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': litConteudosSelecionados.includes(item) }">{{ item }}</span>
                                                    </div>
                                                </div>

                                                <!-- Grupo: Data especial -->
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-data|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-data|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Data especial
                                                </div>
                                                <div v-if="grupoExpandido('lit-data|' + opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in Object.keys(mapaDataEspecialLiteratura())" :key="item" @click="selecionarLitDataEspecial(item)">
                                                        <v-checkbox v-model="litDataEspecialSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': litDataEspecialSelecionados.includes(item) }">{{ item }}</span>
                                                    </div>
                                                </div>

                                                <!-- Grupo: Gêneros textuais -->
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-genero|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-genero|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Gêneros textuais
                                                </div>
                                                <div v-if="grupoExpandido('lit-genero|' + opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in listaGenerosTextuaisLiteratura()" :key="item" @click="selecionarLitGeneroTextual(item)">
                                                        <v-checkbox v-model="litGeneroTextualSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': litGeneroTextualSelecionados.includes(item) }">{{ item }}</span>
                                                    </div>
                                                </div>

                                                <!-- Grupo: Tema -->
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-tema|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-tema|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Tema
                                                </div>
                                                <div v-if="grupoExpandido('lit-tema|' + opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in Object.keys(mapaTemaLiteratura())" :key="item" @click="selecionarLitTema(item)">
                                                        <v-checkbox v-model="litTemaSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': litTemaSelecionados.includes(item) }">{{ item }}</span>
                                                    </div>
                                                </div>

                                                <!-- Grupo: Número de páginas -->
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-paginas|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-paginas|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Número de páginas
                                                </div>
                                                <div v-if="grupoExpandido('lit-paginas|' + opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in listaPaginasLiteratura()" :key="item.valor" @click="selecionarLitPaginas(item.valor)">
                                                        <v-checkbox v-model="litPaginasSelecionados" :value="item.valor" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': litPaginasSelecionados.includes(item.valor) }">{{ item.label }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else v-for="seg in segmentosDisponiveisPara(cat, opcao.valor)" :key="seg">
                                                <!-- Segmento normal: checkbox clicável (Sistema de Ensino e demais categorias) - o próprio
                                                     checkbox já abre/fecha (marcar/desmarcar), sem seta. -->
                                                <div v-if="!segmentoComoTitulo(cat)" class="filtro-checkbox-row filtro-nivel-3" @click="selecionarSegmento(seg, cat, opcao.valor)">
                                                    <v-checkbox
                                                        v-model="segmentosSelecionados"
                                                        :value="seg"
                                                        @click.stop
                                                        @change="resetFiltrosAbaixoSegmento(seg, cat, opcao.valor)"
                                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                    <span :class="{ 'filtro-label-ativo': segmentosSelecionados.includes(seg) }">{{ labelSegmento(seg) }}</span>
                                                </div>
                                                <!-- Segmento como título: dentro de Didáticos, só organiza os filtros de idade/série abaixo -->
                                                <div v-else class="filtro-nivel-3 filtro-segmento-titulo filtro-segmento-titulo-clicavel" @click="toggleSegmentoExpandido(cat, seg, opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ segmentoExpandido(cat, seg, opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    {{ labelSegmento(seg) }}
                                                </div>

                                                <!-- Sub-filtro: Livro do professor/Livro do Aluno (Sistema de Ensino + Anos Finais, só
                                                     Mercado Privado) - pedido pontual pra ficar direto abaixo do Segmento, sem o título
                                                     "Materiais disponíveis", igual o Ensino Médio (materiaisDisponiveisPara cuida da lista) -->
                                                <div v-if="cat === 'Sistema de Ensino' && seg === 'Ensino Fundamental II' && opcao.valor === 'privado' && segmentosSelecionados.includes(seg)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4"
                                                         v-for="material in materiaisDisponiveisPara(seg, opcao.valor)"
                                                         :key="material"
                                                         @click="selecionarMaterial(material)">
                                                        <v-checkbox
                                                            v-model="materiaisSelecionados"
                                                            :value="material"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': materiaisSelecionados.includes(material) }">{{ material }}</span>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Ano de Programa (Sistema de Ensino + EI/EFI, Privado e Público) -->
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroAnoPrograma(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                    <!-- 25/07: 2024 trocado por 2025 pra Educação Infantil e Ensino Fundamental I -
                                                         confirmado via query que 2024 não tem conteúdo relevante (0 em EI, pouco em EF1),
                                                         enquanto 2025 já tem bastante livro cadastrado nos dois segmentos. -->
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="anoProg in ['2025', '2026']" :key="anoProg"
                                                         @click="selecionarAnoPrograma(anoProg)">
                                                        <v-checkbox
                                                            v-model="anoProgramaSelecionados"
                                                            :value="anoProg"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': anoProgramaSelecionados.includes(anoProg) }">{{ anoProg }}</span>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Versão A/B (só para Sistema de Ensino + Educação Infantil) -->
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroVersao(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="versao in ['A', 'B']" :key="versao"
                                                         @click="selecionarVersao(versao)">
                                                        <v-checkbox
                                                            v-model="versoesSelecionadas"
                                                            :value="versao"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': versoesSelecionadas.includes(versao) }">{{ labelVersao(versao) }}</span>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Bimestre/Trimestre (só Sistema de Ensino + EI, Área Pública) -->
                                                <!-- Marcar só o tipo já busca todos os períodos dele; marcar um período específico filtra só aquele -->
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroBimestre(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                    <div v-for="tipo in ['Bimestre', 'Trimestre']" :key="tipo">
                                                        <div class="filtro-checkbox-row filtro-nivel-4" @click="selecionarTipoPeriodo(tipo)">
                                                            <v-checkbox
                                                                v-model="tiposPeriodoSelecionados"
                                                                :value="tipo"
                                                                @click.stop
                                                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                            <span :class="{ 'filtro-label-ativo': tiposPeriodoSelecionados.includes(tipo) }">{{ tipo }}</span>
                                                        </div>
                                                        <!-- Períodos específicos abrem direto embaixo do tipo marcado, sem vir pré-marcados -->
                                                        <div v-if="tiposPeriodoSelecionados.includes(tipo)" class="filtro-nivel-bloco">
                                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in periodosParaTipo(tipo)" :key="item.valor"
                                                                 @click="selecionarPeriodo(item.valor)">
                                                                <v-checkbox
                                                                    v-model="periodosSelecionados"
                                                                    :value="item.valor"
                                                                    @click.stop
                                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                                <span :class="{ 'filtro-label-ativo': periodosSelecionados.includes(item.valor) }">{{ item.label }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Livro do Professor/Aluno (só Sistema de Ensino + Ensino Médio, Privado - Versa) -->
                                                <!-- Professor = título com "FRENTE"; Aluno = título sem "FRENTE" -->
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="tipo in [{ label: 'Livro do Professor', valor: 'Livro do Professor (EM)' }, { label: 'Livro do Aluno', valor: 'Livro do Aluno (EM)' }]" :key="tipo.valor"
                                                         @click="materiaisSelecionados.includes(tipo.valor) ? materiaisSelecionados.splice(materiaisSelecionados.indexOf(tipo.valor), 1) : materiaisSelecionados.push(tipo.valor)">
                                                        <v-checkbox
                                                            v-model="materiaisSelecionados"
                                                            :value="tipo.valor"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': materiaisSelecionados.includes(tipo.valor) }">{{ tipo.label }}</span>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Modalidade (só Sistema de Ensino + Ensino Médio, Privado - Versa) 
                                                 Marcar a Modalidade já inclui as 3 séries dela inteiras (sem sub-nível de série) -->
                                               
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor) && !materiaisSelecionados.includes('Livro do Professor (EM)')" class="filtro-nivel-bloco">
                                                    <div class="filtro-titulo-grupo">Escolha da modalidade</div>
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="modalidade in ['2 anos', '2 anos e meio', '3 anos']" :key="modalidade"
                                                         @click="modalidadesEMSelecionadas.includes(modalidade) ? modalidadesEMSelecionadas.splice(modalidadesEMSelecionadas.indexOf(modalidade), 1) : modalidadesEMSelecionadas.push(modalidade)">
                                                        <v-checkbox
                                                            v-model="modalidadesEMSelecionadas"
                                                            :value="modalidade"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': modalidadesEMSelecionadas.includes(modalidade) }">{{ modalidade }}</span>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Série dentro de cada Modalidade marcada (1ª/2ª/3ª). 
                                                  se não marcar nenhuma série, continua mandando as 3 inteiras da modalidade (comportamento antigo) -->
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor) && modalidadesEMSelecionadas.length > 0" class="filtro-nivel-bloco">
                                                    <div v-for="modalidade in modalidadesEMSelecionadas" :key="'serie-' + modalidade">
                                                        <div class="filtro-titulo-grupo">{{ modalidadesEMSelecionadas.length > 1 ? 'Série (' + modalidade + ')' : 'Série' }}</div>
                                                        <div class="filtro-checkbox-row filtro-nivel-4" v-for="serieEM in seriesParaModalidade(modalidade)" :key="serieEM.valor"
                                                             @click="seriesEMSelecionadas.includes(serieEM.valor) ? seriesEMSelecionadas.splice(seriesEMSelecionadas.indexOf(serieEM.valor), 1) : seriesEMSelecionadas.push(serieEM.valor)">
                                                            <v-checkbox
                                                                v-model="seriesEMSelecionadas"
                                                                :value="serieEM.valor"
                                                                @click.stop
                                                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                            <span :class="{ 'filtro-label-ativo': seriesEMSelecionadas.includes(serieEM.valor) }">{{ serieEM.label }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Sub-filtro: Disciplinas (só Sistema de Ensino + Ensino Médio, Privado - Versa) -->
                                                
                                                <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                    <div class="filtro-titulo-grupo">Disciplinas</div>
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="disciplinaEM in disciplinasEMDisponiveis()" :key="disciplinaEM"
                                                         @click="disciplinasEMSelecionadas.includes(disciplinaEM) ? disciplinasEMSelecionadas.splice(disciplinasEMSelecionadas.indexOf(disciplinaEM), 1) : disciplinasEMSelecionadas.push(disciplinaEM)">
                                                        <v-checkbox
                                                            v-model="disciplinasEMSelecionadas"
                                                            :value="disciplinaEM"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': disciplinasEMSelecionadas.includes(disciplinaEM) }">{{ disciplinaEM }}</span>
                                                    </div>
                                                </div>

                                                <!-- Nível 4 - Ano (abre dentro do Segmento selecionado, ou sempre se o Segmento é só título) -->
                                                <div v-if="((segmentoComoTitulo(cat) && segmentoExpandido(cat, seg, opcao.valor)) || (!segmentoComoTitulo(cat) && segmentosSelecionados.includes(seg))) && temSubFiltroAno(cat, seg)" class="filtro-nivel-bloco">
                                                    <div v-if="tituloNivelAno(cat, seg)" class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('ano|' + cat + '|' + seg + '|' + opcao.valor)">
                                                        <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('ano|' + cat + '|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                        {{ tituloNivelAno(cat, seg) }}
                                                    </div>
                                                    <div v-if="!tituloNivelAno(cat, seg) || grupoExpandido('ano|' + cat + '|' + seg + '|' + opcao.valor)">
                                                        <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in anosParaExibir(cat, seg, opcao.valor)" :key="item.valor"
                                                             @click="selecionarAno(item.valor, cat, seg, opcao.valor)">
                                                            <v-checkbox
                                                                v-model="anosSelecionados"
                                                                :value="item.valor"
                                                                @click.stop
                                                                @change="aposMudarAno(cat, seg, opcao.valor)"
                                                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                            <span :class="{ 'filtro-label-ativo': anosSelecionados.includes(item.valor) }">{{ item.label }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                               
                                                <div v-if="segmentosSelecionados.includes(seg) || segmentoComoTitulo(cat)">

                                                    <!-- Sub-filtro: Versão A/B (Área Pública + EF1, só depois de marcar "1º ano") -->
                                                    <div v-if="temSubFiltroVersaoPublico(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                        <div class="filtro-checkbox-row filtro-nivel-4" v-for="versao in ['A', 'B']" :key="versao"
                                                             @click="selecionarVersao(versao)">
                                                            <v-checkbox
                                                                v-model="versoesSelecionadas"
                                                                :value="versao"
                                                                @click.stop
                                                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                            <span :class="{ 'filtro-label-ativo': versoesSelecionadas.includes(versao) }">{{ labelVersao(versao) }}</span>
                                                        </div>
                                                    </div>

                                                    <!-- Sub-filtro: Materiais disponíveis (só para Sistema de Ensino + EI/EFI) -->
                                                    <div v-if="temSubFiltroMaterial(cat, seg)">
                                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('materiais|' + cat + '|' + seg + '|' + opcao.valor)">
                                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('materiais|' + cat + '|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                            Materiais disponíveis
                                                        </div>
                                                        <div v-if="grupoExpandido('materiais|' + cat + '|' + seg + '|' + opcao.valor)">
                                                            <div class="filtro-checkbox-row filtro-nivel-4"
                                                                 v-for="material in materiaisDisponiveisPara(seg, opcao.valor)"
                                                                 :key="material"
                                                                 @click="selecionarMaterial(material)">
                                                                <v-checkbox
                                                                    v-model="materiaisSelecionados"
                                                                    :value="material"
                                                                    @click.stop
                                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                                <span :class="{ 'filtro-label-ativo': materiaisSelecionados.includes(material) }">{{ material }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Sub-filtro: Componentes Curriculares (só para Didáticos + EI/EFI/EFII/EM) -->
                                                    <div v-if="cat === 'Didáticos' && anoSelecionadoParaSegmento(cat, seg, opcao.valor)">
                                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('componentes|' + seg + '|' + opcao.valor)">
                                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('componentes|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                            Componentes curriculares
                                                        </div>
                                                        <div v-if="grupoExpandido('componentes|' + seg + '|' + opcao.valor)">
                                                            <div class="filtro-checkbox-row filtro-nivel-4"
                                                                 v-for="componente in componentesDisponiveis(seg, opcao.valor)"
                                                                 :key="componente"
                                                                 @click="selecionarComponente(componente)">
                                                                <v-checkbox
                                                                    v-model="componentesSelecionados"
                                                                    :value="componente"
                                                                    @click.stop
                                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                                <span :class="{ 'filtro-label-ativo': componentesSelecionados.includes(componente) }">{{ componente }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Sub-filtro: Coleções (título) - só para Didáticos + Ensino Fundamental I/II,
                                                         aparece depois de marcar o Ano daquele segmento. Lista dinâmica (GetFiltros),
                                                         só coleções que realmente têm obra pra esse Segmento dentro de Didáticos. -->
                                                    <div v-if="cat === 'Didáticos' && (seg === 'Ensino Fundamental I' || seg === 'Ensino Fundamental II' || seg === 'Educação Infantil' || (seg === 'Ensino Médio' && opcao.valor === 'privado')) && anoSelecionadoParaSegmento(cat, seg, opcao.valor)">
                                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('did-colecoes|' + seg + '|' + opcao.valor)">
                                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('did-colecoes|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                            Coleções
                                                        </div>
                                                        <div v-if="grupoExpandido('did-colecoes|' + seg + '|' + opcao.valor)">
                                                            <div class="filtro-checkbox-row filtro-nivel-4"
                                                                 v-for="colecaoItem in colecoesDidaticosDisponiveis(seg, opcao.valor)"
                                                                 :key="colecaoItem"
                                                                 @click="selecionarColecaoDidatico(colecaoItem)">
                                                                <v-checkbox
                                                                    v-model="colecoesDidaticosSelecionados"
                                                                    :value="colecaoItem"
                                                                    @click.stop
                                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                                <span :class="{ 'filtro-label-ativo': colecoesDidaticosSelecionados.includes(colecaoItem) }">{{ colecaoItem }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Sub-filtro: Categoria de apoio (só para Apoio + EI/EFI/EFII/EM, depois de marcar a idade/série) -->
                                                    <div v-if="temSubFiltroApoio(cat, seg, opcao.valor)">
                                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('apoio-cat|' + opcao.valor)">
                                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('apoio-cat|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                            Categorias de apoio
                                                        </div>
                                                        <div v-if="grupoExpandido('apoio-cat|' + opcao.valor)">
                                                            <div class="filtro-checkbox-row filtro-nivel-4"
                                                                 v-for="apoio in apoioDisponiveis(seg, opcao.valor)"
                                                                 :key="apoio"
                                                                 @click="selecionarApoio(apoio)">
                                                                <v-checkbox
                                                                    v-model="apoioSelecionados"
                                                                    :value="apoio"
                                                                    @click.stop
                                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                                <span :class="{ 'filtro-label-ativo': apoioSelecionados.includes(apoio) }">{{ apoio }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Sub-filtro: Materiais disponíveis (Literatura, só depois de marcar o Ano - coleções reais) -->
                                                    <div v-if="cat === 'Literatura' && anoSelecionadoParaSegmento(cat, seg, opcao.valor) && materiaisLiteraturaPara(opcao.valor, seg).length > 0">
                                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('materiais-lit|' + seg + '|' + opcao.valor)">
                                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('materiais-lit|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                            Materiais disponíveis
                                                        </div>
                                                        <div v-if="grupoExpandido('materiais-lit|' + seg + '|' + opcao.valor)">
                                                            <div class="filtro-checkbox-row filtro-nivel-4"
                                                                 v-for="material in materiaisLiteraturaPara(opcao.valor, seg)"
                                                                 :key="material"
                                                                 @click="selecionarMaterialLiteratura(material)">
                                                                <v-checkbox
                                                                    v-model="materiaisLiteraturaSelecionados"
                                                                    :value="material"
                                                                    @click.stop
                                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                                <span :class="{ 'filtro-label-ativo': materiaisLiteraturaSelecionados.includes(material) }">{{ material }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </v-sheet>
                </v-bottom-sheet>


                <!-- Filtro Desktop - Árvore de 4 níveis em cascata -->
                <v-card width="280" outlined class="filtro float-left hidden-sm-and-down">
                    <v-list-item class="title">
                        <v-list-item-content>
                            <v-list-item-title>
                                Filtros
                                <v-btn v-if="mercadosSelecionados.length > 0" icon small class="float-right" @click="limparArvoreFiltros" title="Limpar filtros">
                                    <v-icon small>close</v-icon>
                                </v-btn>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>

                    <!-- Nível 1 - Mercado (cada opção pode expandir sua própria ramificação) -->
                    <div v-for="opcao in opcoesMercado" :key="opcao.valor" class="filtro-mercado-item">
                        <div class="filtro-checkbox-row filtro-nivel-1" @click="selecionarMercado(opcao.valor)">
                            <v-checkbox
                                :input-value="mercadosSelecionados.includes(opcao.valor)"
                                @click.stop="selecionarMercado(opcao.valor)"
                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                            <span :class="{ 'filtro-label-ativo': mercadosSelecionados.includes(opcao.valor) }">{{ opcao.label }}</span>
                        </div>

                        <!-- Nível 2 - Categoria (abre dentro do Mercado selecionado) -->
                        <div v-if="mercadosSelecionados.includes(opcao.valor)" class="filtro-nivel-bloco">
                            <div v-for="cat in categoriasDisponiveis" :key="cat">
                                <div class="filtro-checkbox-row filtro-nivel-2" @click="selecionarCategoria(cat, opcao.valor)">
                                    <v-checkbox
                                        v-model="categoriasSelecionadas"
                                        :value="cat"
                                        @click.stop
                                        @change="resetFiltrosAbaixoCategoria(cat, opcao.valor)"
                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                    <span :class="{ 'filtro-label-ativo': categoriasSelecionadas.includes(cat) }">{{ cat }}</span>
                                </div>

                                <!-- Nível 3 - Segmento (abre dentro da Categoria selecionada) -->
                                <div v-if="categoriasSelecionadas.includes(cat)" class="filtro-nivel-bloco">
                                    <div v-if="cat === 'Literatura'">
                                        <!-- Grupo: Ano / Série -->
                                       
                                        <div v-for="grupo in literaturaAnoSerieGrupos()" :key="grupo.titulo">
                                            <div class="filtro-nivel-3 filtro-segmento-titulo filtro-segmento-titulo-clicavel" @click="toggleGrupoExpandido('lit-seg|' + grupo.titulo + '|' + opcao.valor)">
                                                <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-seg|' + grupo.titulo + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                {{ grupo.titulo }}
                                            </div>
                                            <div v-if="grupoExpandido('lit-seg|' + grupo.titulo + '|' + opcao.valor)" class="filtro-nivel-bloco">
                                                <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in grupo.itens" :key="item.chave" @click="selecionarLitAnoSerie(item.chave)">
                                                    <v-checkbox v-model="litAnoSerieSelecionados" :value="item.chave" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                    <span :class="{ 'filtro-label-ativo': litAnoSerieSelecionados.includes(item.chave) }">{{ item.label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Grupo: Autor / Ilustrador 2-->
                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-autor|' + opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-autor|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            Autor / Ilustrador
                                        </div>
                                        <div v-if="grupoExpandido('lit-autor|' + opcao.valor)" class="filtro-nivel-bloco busca-autor">
                                            <v-autocomplete
                                                v-model="autoresAdicionados"
                                                :items="autoresLiteraturaDisponiveis()"
                                                multiple
                                                dense
                                                hide-details
                                                clearable
                                                placeholder="Buscar autor"
                                                class="filtro-autocomplete filtro-nivel-4"
                                            ></v-autocomplete>
                                        </div>

                                        <!-- Grupo: Coleções -->
                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-colecoes|' + opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-colecoes|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            Coleções
                                        </div>
                                        <div v-if="grupoExpandido('lit-colecoes|' + opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="colecao in colecoesLiteraturaDisponiveis()" :key="colecao" @click="filterColecao(colecao)">
                                                <v-checkbox :input-value="colecoesAdicionadas.includes(colecao)" @click.stop="filterColecao(colecao)" color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': colecoesAdicionadas.includes(colecao) }">{{ colecao }}</span>
                                            </div>
                                        </div>

                                        <!-- Grupo: Conteúdos disciplinares -->
                                        
                                        <div v-if="false" class="filtro-titulo-grupo">Conteúdos disciplinares</div>
                                        <div v-if="false" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in Object.keys(mapaConteudosLiteratura()).sort((a, b) => a.localeCompare(b, 'pt-BR'))" :key="item" @click="selecionarLitConteudo(item)">
                                                <v-checkbox v-model="litConteudosSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': litConteudosSelecionados.includes(item) }">{{ item }}</span>
                                            </div>
                                        </div>

                                        <!-- Grupo: Data especial -->
                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-data|' + opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-data|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            Data especial
                                        </div>
                                        <div v-if="grupoExpandido('lit-data|' + opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in Object.keys(mapaDataEspecialLiteratura())" :key="item" @click="selecionarLitDataEspecial(item)">
                                                <v-checkbox v-model="litDataEspecialSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': litDataEspecialSelecionados.includes(item) }">{{ item }}</span>
                                            </div>
                                        </div>

                                        <!-- Grupo: Gêneros textuais -->
                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-genero|' + opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-genero|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            Gêneros textuais
                                        </div>
                                        <div v-if="grupoExpandido('lit-genero|' + opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in listaGenerosTextuaisLiteratura()" :key="item" @click="selecionarLitGeneroTextual(item)">
                                                <v-checkbox v-model="litGeneroTextualSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': litGeneroTextualSelecionados.includes(item) }">{{ item }}</span>
                                            </div>
                                        </div>

                                        <!-- Grupo: Tema -->
                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-tema|' + opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-tema|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            Tema
                                        </div>
                                        <div v-if="grupoExpandido('lit-tema|' + opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in Object.keys(mapaTemaLiteratura())" :key="item" @click="selecionarLitTema(item)">
                                                <v-checkbox v-model="litTemaSelecionados" :value="item" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': litTemaSelecionados.includes(item) }">{{ item }}</span>
                                            </div>
                                        </div>

                                        <!-- Grupo: Número de páginas -->
                                        <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('lit-paginas|' + opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('lit-paginas|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            Número de páginas
                                        </div>
                                        <div v-if="grupoExpandido('lit-paginas|' + opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in listaPaginasLiteratura()" :key="item.valor" @click="selecionarLitPaginas(item.valor)">
                                                <v-checkbox v-model="litPaginasSelecionados" :value="item.valor" @click.stop color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': litPaginasSelecionados.includes(item.valor) }">{{ item.label }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else v-for="seg in segmentosDisponiveisPara(cat, opcao.valor)" :key="seg">
                                        <!-- Segmento normal: checkbox clicável (Sistema de Ensino e demais categorias) - o próprio
                                             checkbox já abre/fecha (marcar/desmarcar), sem seta. -->
                                        <div v-if="!segmentoComoTitulo(cat)" class="filtro-checkbox-row filtro-nivel-3" @click="selecionarSegmento(seg, cat, opcao.valor)">
                                            <v-checkbox
                                                v-model="segmentosSelecionados"
                                                :value="seg"
                                                @click.stop
                                                @change="resetFiltrosAbaixoSegmento(seg, cat, opcao.valor)"
                                                color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                            <span :class="{ 'filtro-label-ativo': segmentosSelecionados.includes(seg) }">{{ labelSegmento(seg) }}</span>
                                        </div>
                                        <!-- Segmento como título: dentro de Didáticos, só organiza os filtros de idade/série abaixo -->
                                        <div v-else class="filtro-nivel-3 filtro-segmento-titulo filtro-segmento-titulo-clicavel" @click="toggleSegmentoExpandido(cat, seg, opcao.valor)">
                                            <v-icon small class="filtro-seta-expandir">{{ segmentoExpandido(cat, seg, opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                            {{ labelSegmento(seg) }}
                                        </div>

                                        <!-- Sub-filtro: Livro do professor/Livro do Aluno (Sistema de Ensino + Anos Finais, só
                                             Mercado Privado) - pedido pontual, ver comentário completo no bloco equivalente acima. -->
                                        <div v-if="cat === 'Sistema de Ensino' && seg === 'Ensino Fundamental II' && opcao.valor === 'privado' && segmentosSelecionados.includes(seg)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4"
                                                 v-for="material in materiaisDisponiveisPara(seg, opcao.valor)"
                                                 :key="material"
                                                 @click="selecionarMaterial(material)">
                                                <v-checkbox
                                                    v-model="materiaisSelecionados"
                                                    :value="material"
                                                    @click.stop
                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': materiaisSelecionados.includes(material) }">{{ material }}</span>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Ano de Programa (Sistema de Ensino + EI/EFI, Privado e Público) -->
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroAnoPrograma(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                            <!--  2024 trocado por 2025 - ver comentário completo no bloco equivalente acima. -->
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="anoProg in ['2025', '2026']" :key="anoProg"
                                                 @click="selecionarAnoPrograma(anoProg)">
                                                <v-checkbox
                                                    v-model="anoProgramaSelecionados"
                                                    :value="anoProg"
                                                    @click.stop
                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': anoProgramaSelecionados.includes(anoProg) }">{{ anoProg }}</span>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Versão A/B (só para Sistema de Ensino + Educação Infantil) -->
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroVersao(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="versao in ['A', 'B']" :key="versao"
                                                 @click="selecionarVersao(versao)">
                                                <v-checkbox
                                                    v-model="versoesSelecionadas"
                                                    :value="versao"
                                                    @click.stop
                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': versoesSelecionadas.includes(versao) }">{{ labelVersao(versao) }}</span>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Bimestre/Trimestre (só Sistema de Ensino + EI, Área Pública) -->
                                        <!-- Marcar só o tipo já busca todos os períodos dele; marcar um período específico filtra só aquele -->
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroBimestre(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                            <div v-for="tipo in ['Bimestre', 'Trimestre']" :key="tipo">
                                                <div class="filtro-checkbox-row filtro-nivel-4" @click="selecionarTipoPeriodo(tipo)">
                                                    <v-checkbox
                                                        v-model="tiposPeriodoSelecionados"
                                                        :value="tipo"
                                                        @click.stop
                                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                    <span :class="{ 'filtro-label-ativo': tiposPeriodoSelecionados.includes(tipo) }">{{ tipo }}</span>
                                                </div>
                                                <!-- Períodos específicos abrem direto embaixo do tipo marcado, sem vir pré-marcados -->
                                                <div v-if="tiposPeriodoSelecionados.includes(tipo)" class="filtro-nivel-bloco">
                                                    <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in periodosParaTipo(tipo)" :key="item.valor"
                                                         @click="selecionarPeriodo(item.valor)">
                                                        <v-checkbox
                                                            v-model="periodosSelecionados"
                                                            :value="item.valor"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': periodosSelecionados.includes(item.valor) }">{{ item.label }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Livro do Professor/Aluno (só Sistema de Ensino + Ensino Médio, Privado - Versa) -->
                                        <!-- Professor = título com "FRENTE"; Aluno = título sem "FRENTE" -->
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="tipo in [{ label: 'Livro do Professor', valor: 'Livro do Professor (EM)' }, { label: 'Livro do Aluno', valor: 'Livro do Aluno (EM)' }]" :key="tipo.valor"
                                                 @click="materiaisSelecionados.includes(tipo.valor) ? materiaisSelecionados.splice(materiaisSelecionados.indexOf(tipo.valor), 1) : materiaisSelecionados.push(tipo.valor)">
                                                <v-checkbox
                                                    v-model="materiaisSelecionados"
                                                    :value="tipo.valor"
                                                    @click.stop
                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': materiaisSelecionados.includes(tipo.valor) }">{{ tipo.label }}</span>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Modalidade (só Sistema de Ensino + Ensino Médio, Privado - Versa) -->
                                        <!-- Marcar a Modalidade já inclui as 3 séries dela inteiras (sem sub-nível de série) -->
                                       
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor) && !materiaisSelecionados.includes('Livro do Professor (EM)')" class="filtro-nivel-bloco">
                                            <div class="filtro-titulo-grupo">Escolha da modalidade</div>
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="modalidade in ['2 anos', '2 anos e meio', '3 anos']" :key="modalidade"
                                                 @click="modalidadesEMSelecionadas.includes(modalidade) ? modalidadesEMSelecionadas.splice(modalidadesEMSelecionadas.indexOf(modalidade), 1) : modalidadesEMSelecionadas.push(modalidade)">
                                                <v-checkbox
                                                    v-model="modalidadesEMSelecionadas"
                                                    :value="modalidade"
                                                    @click.stop
                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': modalidadesEMSelecionadas.includes(modalidade) }">{{ modalidade }}</span>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Série dentro de cada Modalidade marcada (1ª/2ª/3ª). 25/07: opcional -
                                             se não marcar nenhuma série, continua mandando as 3 inteiras da modalidade (comportamento antigo) -->
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor) && modalidadesEMSelecionadas.length > 0" class="filtro-nivel-bloco">
                                            <div v-for="modalidade in modalidadesEMSelecionadas" :key="'serie-' + modalidade">
                                                <div class="filtro-titulo-grupo">{{ modalidadesEMSelecionadas.length > 1 ? 'Série (' + modalidade + ')' : 'Série' }}</div>
                                                <div class="filtro-checkbox-row filtro-nivel-4" v-for="serieEM in seriesParaModalidade(modalidade)" :key="serieEM.valor"
                                                     @click="seriesEMSelecionadas.includes(serieEM.valor) ? seriesEMSelecionadas.splice(seriesEMSelecionadas.indexOf(serieEM.valor), 1) : seriesEMSelecionadas.push(serieEM.valor)">
                                                    <v-checkbox
                                                        v-model="seriesEMSelecionadas"
                                                        :value="serieEM.valor"
                                                        @click.stop
                                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                    <span :class="{ 'filtro-label-ativo': seriesEMSelecionadas.includes(serieEM.valor) }">{{ serieEM.label }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Sub-filtro: Disciplinas (só Sistema de Ensino + Ensino Médio, Privado - Versa) -->
                                       
                                        <div v-if="segmentosSelecionados.includes(seg) && temSubFiltroModalidadeEM(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                            <div class="filtro-titulo-grupo">Disciplinas</div>
                                            <div class="filtro-checkbox-row filtro-nivel-4" v-for="disciplinaEM in disciplinasEMDisponiveis()" :key="disciplinaEM"
                                                 @click="disciplinasEMSelecionadas.includes(disciplinaEM) ? disciplinasEMSelecionadas.splice(disciplinasEMSelecionadas.indexOf(disciplinaEM), 1) : disciplinasEMSelecionadas.push(disciplinaEM)">
                                                <v-checkbox
                                                    v-model="disciplinasEMSelecionadas"
                                                    :value="disciplinaEM"
                                                    @click.stop
                                                    color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                <span :class="{ 'filtro-label-ativo': disciplinasEMSelecionadas.includes(disciplinaEM) }">{{ disciplinaEM }}</span>
                                            </div>
                                        </div>

                                        <!-- Nível 4 - Ano (abre dentro do Segmento selecionado, ou sempre se o Segmento é só título) -->
                                        <div v-if="((segmentoComoTitulo(cat) && segmentoExpandido(cat, seg, opcao.valor)) || (!segmentoComoTitulo(cat) && segmentosSelecionados.includes(seg))) && temSubFiltroAno(cat, seg)" class="filtro-nivel-bloco">
                                            <div v-if="tituloNivelAno(cat, seg)" class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('ano|' + cat + '|' + seg + '|' + opcao.valor)">
                                                <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('ano|' + cat + '|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                {{ tituloNivelAno(cat, seg) }}
                                            </div>
                                            <div v-if="!tituloNivelAno(cat, seg) || grupoExpandido('ano|' + cat + '|' + seg + '|' + opcao.valor)">
                                                <div class="filtro-checkbox-row filtro-nivel-4" v-for="item in anosParaExibir(cat, seg, opcao.valor)" :key="item.valor"
                                                     @click="selecionarAno(item.valor, cat, seg, opcao.valor)">
                                                    <v-checkbox
                                                        v-model="anosSelecionados"
                                                        :value="item.valor"
                                                        @click.stop
                                                        @change="aposMudarAno(cat, seg, opcao.valor)"
                                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                    <span :class="{ 'filtro-label-ativo': anosSelecionados.includes(item.valor) }">{{ item.label }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div v-if="segmentosSelecionados.includes(seg) || segmentoComoTitulo(cat)">
                                            <!-- Sub-filtro: Versão A/B (Área Pública + EF1, só depois de marcar "1º ano") -->
                                            <div v-if="temSubFiltroVersaoPublico(cat, seg, opcao.valor)" class="filtro-nivel-bloco">
                                                <div class="filtro-checkbox-row filtro-nivel-4" v-for="versao in ['A', 'B']" :key="versao"
                                                     @click="selecionarVersao(versao)">
                                                    <v-checkbox
                                                        v-model="versoesSelecionadas"
                                                        :value="versao"
                                                        @click.stop
                                                        color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                    <span :class="{ 'filtro-label-ativo': versoesSelecionadas.includes(versao) }">{{ labelVersao(versao) }}</span>
                                                </div>
                                            </div>

                                            <!-- Sub-filtro: Materiais disponíveis (só para Sistema de Ensino + EI/EFI) -->
                                            <div v-if="temSubFiltroMaterial(cat, seg)">
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('materiais|' + cat + '|' + seg + '|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('materiais|' + cat + '|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Materiais disponíveis
                                                </div>
                                                <div v-if="grupoExpandido('materiais|' + cat + '|' + seg + '|' + opcao.valor)">
                                                    <div class="filtro-checkbox-row filtro-nivel-4"
                                                         v-for="material in materiaisDisponiveisPara(seg, opcao.valor)"
                                                         :key="material"
                                                         @click="selecionarMaterial(material)">
                                                        <v-checkbox
                                                            v-model="materiaisSelecionados"
                                                            :value="material"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': materiaisSelecionados.includes(material) }">{{ material }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Sub-filtro: Componentes Curriculares (só para Didáticos + EI/EFI/EFII/EM) -->
                                            <div v-if="cat === 'Didáticos' && anoSelecionadoParaSegmento(cat, seg, opcao.valor)">
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('componentes|' + seg + '|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('componentes|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Componentes curriculares
                                                </div>
                                                <div v-if="grupoExpandido('componentes|' + seg + '|' + opcao.valor)">
                                                    <div class="filtro-checkbox-row filtro-nivel-4"
                                                         v-for="componente in componentesDisponiveis(seg, opcao.valor)"
                                                         :key="componente"
                                                         @click="selecionarComponente(componente)">
                                                        <v-checkbox
                                                            v-model="componentesSelecionados"
                                                            :value="componente"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': componentesSelecionados.includes(componente) }">{{ componente }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Sub-filtro: Coleções (título) - só para Didáticos + Ensino Fundamental I/II,
                                                 aparece depois de marcar o Ano daquele segmento. Lista dinâmica (GetFiltros),
                                                 só coleções que realmente têm obra pra esse Segmento dentro de Didáticos. -->
                                            <div v-if="cat === 'Didáticos' && (seg === 'Ensino Fundamental I' || seg === 'Ensino Fundamental II' || seg === 'Educação Infantil' || (seg === 'Ensino Médio' && opcao.valor === 'privado')) && anoSelecionadoParaSegmento(cat, seg, opcao.valor)">
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('did-colecoes|' + seg + '|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('did-colecoes|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Coleções
                                                </div>
                                                <div v-if="grupoExpandido('did-colecoes|' + seg + '|' + opcao.valor)">
                                                    <div class="filtro-checkbox-row filtro-nivel-4"
                                                         v-for="colecaoItem in colecoesDidaticosDisponiveis(seg, opcao.valor)"
                                                         :key="colecaoItem"
                                                         @click="selecionarColecaoDidatico(colecaoItem)">
                                                        <v-checkbox
                                                            v-model="colecoesDidaticosSelecionados"
                                                            :value="colecaoItem"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': colecoesDidaticosSelecionados.includes(colecaoItem) }">{{ colecaoItem }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Sub-filtro: Categoria de apoio (só para Apoio + EI/EFI/EFII/EM, depois de marcar a idade/série) -->
                                            <div v-if="temSubFiltroApoio(cat, seg, opcao.valor)">
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('apoio-cat|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('apoio-cat|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Categorias de apoio
                                                </div>
                                                <div v-if="grupoExpandido('apoio-cat|' + opcao.valor)">
                                                    <div class="filtro-checkbox-row filtro-nivel-4"
                                                         v-for="apoio in apoioDisponiveis(seg, opcao.valor)"
                                                         :key="apoio"
                                                         @click="selecionarApoio(apoio)">
                                                        <v-checkbox
                                                            v-model="apoioSelecionados"
                                                            :value="apoio"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': apoioSelecionados.includes(apoio) }">{{ apoio }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Sub-filtro: Materiais disponíveis (Literatura, só depois de marcar o Ano - coleções reais) -->
                                            <div v-if="cat === 'Literatura' && anoSelecionadoParaSegmento(cat, seg, opcao.valor) && materiaisLiteraturaPara(opcao.valor, seg).length > 0">
                                                <div class="filtro-titulo-grupo filtro-titulo-grupo-clicavel" @click="toggleGrupoExpandido('materiais-lit|' + seg + '|' + opcao.valor)">
                                                    <v-icon small class="filtro-seta-expandir">{{ grupoExpandido('materiais-lit|' + seg + '|' + opcao.valor) ? 'expand_more' : 'chevron_right' }}</v-icon>
                                                    Materiais disponíveis
                                                </div>
                                                <div v-if="grupoExpandido('materiais-lit|' + seg + '|' + opcao.valor)">
                                                    <div class="filtro-checkbox-row filtro-nivel-4"
                                                         v-for="material in materiaisLiteraturaPara(opcao.valor, seg)"
                                                         :key="material"
                                                         @click="selecionarMaterialLiteratura(material)">
                                                        <v-checkbox
                                                            v-model="materiaisLiteraturaSelecionados"
                                                            :value="material"
                                                            @click.stop
                                                            color="primary" hide-details class="filtro-checkbox"></v-checkbox>
                                                        <span :class="{ 'filtro-label-ativo': materiaisLiteraturaSelecionados.includes(material) }">{{ material }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>

                <v-row class="grid" align="stretch">
                    <v-container fluid grid-list-md class="pt-0">

                        <!-- Skeleton loading -->
                        <v-layout row wrap v-if="loading">
                            <v-flex xs12 sm6 md4 lg4 v-for="n in 12" :key="'skeleton-'+n">
                                <v-card class="ml-1 mb-1 ml-sm-4 mb-sm-4" outlined>
                                    <v-skeleton-loader type="image, article, button"></v-skeleton-loader>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <!-- Grid de livros -->
                        <v-layout row wrap id="livros-list" v-else>
                            <v-flex xs12 sm6 md4 lg4 v-for="(card, index) in cards" :key="card.isbn + '-' + card.complemento">
                                <v-hover v-slot:default="{ hover }">
                                    <a>
                                        <v-card height="100%" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }"
                                            outlined class="box-con-catalog ml-1 mb-1 ml-sm-4 mb-sm-4 flex v-flex flex-column">
                                           
                                            <v-img :src="card.src" :lazy-src="capaPlaceholder" :eager="index < 6"
                                                   height="200px" class="ma-4" :transition="false"
                                                   style="background-color: #ffffff !important;">
                                                <template v-slot:placeholder>
                                                    <v-row class="fill-height ma-0 white" align="center" justify="center">
                                                        <v-progress-circular indeterminate color="grey lighten-3" size="24"></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>
                                            <v-card-title v-text="card.title" @click="abrirFlipbook(card.arquivo, card.isbn, card.complemento)"></v-card-title>
                                            <v-card-actions>
                                                <v-btn large block tile depressed @click="abrirFlipbook(card.arquivo, card.isbn, card.complemento)">Visualizar</v-btn>
                                                <v-btn large block tile depressed class="bot-info" @click="Visualizacao(card.arquivo, card.isbn, card.complemento)">Informações</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </a>
                                </v-hover>
                            </v-flex>
                        </v-layout>

                        <!-- Indicador de pré-carregamento em segundo plano -->
                        <v-row class="d-flex justify-center mt-2" v-if="carregandoMais && !loading">
                            <v-progress-linear indeterminate color="primary" height="2" style="max-width:200px"></v-progress-linear>
                            <span class="ml-2 caption grey--text align-self-center">Pré-carregando páginas...</span>
                        </v-row>

                        <p v-if="cards.length == 0 && !loading">Não existe um livro com base nos filtros selecionados.</p>

                        <!-- Contador de resultados -->
                        <v-row class="d-flex justify-center mt-2 mb-2" v-if="!loading && totalRegistros > 0">
                            <span class="caption grey--text">{{ totalRegistros }} obra(s) encontrada(s)</span>
                        </v-row>

                        <!-- Paginação -->
                        <v-row class="d-flex justify-center mt-2 mb-8" v-if="!loading && totalPaginas > 1">
                            <v-pagination
                                v-model="paginaAtual"
                                :length="totalPaginas"
                                :total-visible="7"
                                circle
                                color="primary"
                                @input="onPaginaChange">
                            </v-pagination>
                        </v-row>

                        <!-- Modais -->
                        <v-dialog v-model="dialogerror" persistent max-width="360" content-class="box-dialog-inf error-api">
                            <v-btn color="blue darken-1" class="bot-exit" text @click="dialogerror = false">
                                <v-img src="@/assets/iconexit.png" title="Sair" />
                            </v-btn>
                            <v-card>
                                <div class="box-infoerro">
                                    <v-img src="@/assets/icon-triste.png" title="Sem informação" />
                                    Não foi possivel achar as informações!
                                </div>
                            </v-card>
                        </v-dialog>

                        <v-dialog v-model="dialog" persistent max-width="100%" content-class="box-dialog-inf">
                            <div class="container">
                                <v-btn color="blue darken-1" class="bot-exit" text @click="dialog = false">
                                    <v-img src="@/assets/iconexit.png" title="Sair" />
                                </v-btn>
                                <v-card>
                                    <div id="conteudoInfo">
                                        <div class="box-imagem">
                                            <img id="livroid" :src="informacoes.imagemCapa" />
                                            <a id="bot-livro" target="_blank">
                                                <v-btn large block tile depressed class="bot-livro" id="bot-livro" @click="abrirFlipbook(informacoes.flipbookURL, informacoes.isbn, 0)">Visualizar livro</v-btn>
                                            </a>
                                        </div>
                                        <div class="box-txt">
                                            <div class="infTitle">
                                                <v-img src="@/assets/icon-titulo.jpg" content-class="icon-tit" /><div id="InNome"> {{informacoes.nomeTitulo}}</div>
                                            </div>
                                            <div class="infAtributos">
                                                <v-img src="@/assets/icon-atributos.jpg" /> <div id="InAutor">Autor(es): {{ informacoes.autorNomeCapa }}</div>
                                            </div>
                                            <div class="infAtributos">
                                                <v-img src="@/assets/icon-atributos.jpg" /> <div id="InSegmento">Segmento: {{ informacoes.segmento }}</div>
                                            </div>
                                            <div id="infDescricao">{{ informacoes.resumo }}</div>
                                            <div id="infISBN"><strong>ISBN: {{ informacoes.isbn }}</strong></div>
                                            <div class="box-inf-detalhe">
                                                <div class="pag-de">Páginas<div id="infPagina">{{ informacoes.paginas }}</div></div>
                                                <div class="pag-de">Formato<div id="infFormato">{{ informacoes.formato }}</div></div>
                                                <div class="pag-de">Ano<div id="infAno">{{ informacoes.ano }}</div></div>
                                                <div class="pag-de">Disciplina<div id="infDisciplina">{{ informacoes.disciplina }}</div></div>
                                            </div>
                                            <div class="box-inf-detalhe" id="v-video">
                                                <div class="tiu-video">Conheça</div>
                                                <a id="link-video" target="_blank">
                                                    <v-img src="@/assets/icon-video.jpg" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </div>
                        </v-dialog>
                    </v-container>
                </v-row>
            </v-container>
        </section>

        <!-- <a href="https://api.whatsapp.com/send?phone=5511972337522&text=Oi!" class="float" target="_blank" v-if="ebsa">
            <img src="../assets/whats.png" alt="Whatsapp" class="my-float img-responsive">
            <img src="../assets/Robo.svg" alt="Whatsapp" class="robo-aj">
        </a> -->
    </div>
</template>

<script>
import $ from 'jquery';
import { VueAutosuggest } from "vue-autosuggest";
import { generateTokenAPI, http } from "../services/APIservice";
import HeaderLogado from "./HeaderLogado";

const PAGE_SIZE = 24; // 3 colunas × 8 linhas

export default {
    name: "Catalogo",
    components: { VueAutosuggest, HeaderLogado },

    created() {
        try {
            const storage = JSON.parse(localStorage.getItem('user'));
            this.userName = storage.userName.split(' ')[0];
        } catch (error) {
            console.log(error);
        }
    },

    data() {
        return {
            dialogerror: false,
            dialog: false,
            userName: "",
            drawer: false,
            ebsa: false,

            // Filtros disponíveis (populados pela API /GetFiltros - sem paginação)
            segmentosTodos: [],   // todos os segmentos existentes no banco
            anosTodos: [],        // todos os anos existentes no banco
            colecoes: [],
            disciplinas: [],
            autores: [],
            categoriasTodas: [],  // Sistema de Ensino, Didáticos, Apoio, Literatura
            // Placeholder 1x1 transparente (PNG base64) - dispara o lazy-load real do
            // Vuetify (IntersectionObserver) nos cards do catálogo, sem custo de rede
            capaPlaceholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=',

            // Filtros escopados (carregados sob demanda, só ao entrar na categoria Literatura -
            // diferente dos de cima, que são globais e usados pelas outras categorias).
            // Chaveado por mercado ('privado'/'publico'), já que os livros de Literatura
            // disponíveis mudam de acordo com a Rede liberada pra cada um.
            literaturaCache: {}, // ex: { privado: { segmentos: [...], anos: [...] }, publico: {...} }
            literaturaSegmentoCache: {}, // chave "mercado|segmento" -> { anos: [...], materiais: [...] }
            didaticosColecaoCache: {}, // chave "mercado|segmento" -> [colecoes...] - sub-filtro Coleções (Didáticos EF1/EF2, e EI/Público)
            componentesDidaticosCache: {}, // chave "mercado|segmento" -> [disciplinas...] - sub-filtro Componentes dinâmico (Didáticos + Educação Infantil/Público)

            // Árvore de filtros em cascata (Nível 1 → 2 → 3 → 4)
            opcoesMercado: [
                { label: 'Mercado Privado', valor: 'privado' },
                { label: 'Mercado Público', valor: 'publico' } // 25/07: era "Área Pública" - só o rótulo mudou, valor continua 'publico'
            ],
            mercadosSelecionados: [],    // ex: ['privado', 'publico'] - pode marcar os dois juntos
            categoriasSelecionadas: [], // ex: ['Didáticos', 'Apoio']
            segmentosSelecionados: [],   // ex: ['Ensino Fundamental I', 'Ensino Médio']
            gruposExpandidos: [],    // ex: ['Apoio|Educação Infantil|publico', 'apoio-cat|Ensino Fundamental II|publico'] - collapse/expand de qualquer título de grupo da árvore
            anosSelecionados: [],        // ex: ['1º ano', '2º ano']
            versoesSelecionadas: [],     // ex: ['A', 'B'] - sub-filtro de Educação Infantil (Sistema de Ensino)
            anoProgramaSelecionados: [], // ex: ['2025', '2026'] - sub-filtro Sistema de Ensino EI/EF1 (Privado e Público)
            litAnoSerieSelecionados: [],     // ex: ['EI_0_3', 'EF1_1_3'] - árvore fixa de Ano/Série (Literatura)
            litGeneroTextualSelecionados: [],// ex: ['CONTO', 'POEMA'] - Gêneros textuais (Literatura)
            litTemaSelecionados: [],         // ex: ['AMIZADE', 'FAMÍLIA'] - Tema/Assunto (Literatura)
            litDataEspecialSelecionados: [], // ex: ['NATAL'] - Data especial (Literatura)
            litPaginasSelecionados: [],      // ex: ['0-31', '32-48'] - Número de páginas (Literatura)
            litConteudosSelecionados: [],    // ex: ['História', 'Arte'] - Conteúdos disciplinares (Literatura)
            materiaisSelecionados: [],   // ex: ['Diário da Criança', 'Cartazes'] - sub-filtro EI/EFI (Sistema de Ensino)
            componentesSelecionados: [], // ex: ['Matemática', 'História'] - sub-filtro Didáticos (labels amigáveis, traduzidos pro valor real de materia no buildParams)
            apoioSelecionados: [], // ex: ['Educação Financeira', 'Caderno de Atividades'] - sub-filtro Apoio (mix de materia + busca por título)
            tiposPeriodoSelecionados: [], // ex: ['Bimestre'] - sub-filtro Área Pública (Bimestre/Trimestre)
            periodosSelecionados: [],     // ex: ['1º Bimestre', '2º Bimestre'] - valores específicos dentro do tipo
            modalidadesEMSelecionadas: [], // ex: ['3 anos'] - sub-filtro Sistema de Ensino/Ensino Médio/Privado (Versa)
            seriesEMSelecionadas: [],      // ex: ['3ANOS_1'] - sub-sub-filtro de série dentro da Modalidade (opcional; se vazio, manda as 3 séries inteiras da modalidade, como antes)
            disciplinasEMSelecionadas: [], // ex: ['Biologia', 'Língua Espanhola'] - sub-filtro Disciplinas (Ensino Médio/Privado), guarda o rótulo bonito (ver mapaDisciplinasEM)
            disciplinasEMCache: {},        // chave: chaves de modalidade/série ordenadas e unidas por vírgula -> [disciplinas...]
            materiaisLiteraturaSelecionados: [], // ex: ['Literatura', 'Leiturativa'] - coleções reais usadas como Materiais disponíveis
            colecoesDidaticosSelecionados: [], // ex: ['BRINCANDO COM', 'CRESCER'] - sub-filtro Coleções (Didáticos EF1/EF2)

            // Filtros adicionais (Coleção, Disciplina, Autor) continuam multi-seleção
            colecoesAdicionadas: [],
            disciplinasAdicionadas: [],
            autoresAdicionados: [],

            // Estado de carregamento
            loading: true,
            carregandoMais: false,
            requestToken: 0, // invalida respostas de requisições antigas quando o filtro troca rápido
            paginaRequestToken: 0, 

            // Cache de páginas pré-carregadas
            paginasCache: {},

            // Paginação vinda da API
            paginaAtual: 1,
            totalPaginas: 0,
            totalRegistros: 0,

            // Livros exibidos na tela
            cards: [],

            // Sugestões de busca
            suggestions: [{ data: [] }],
            query: "",
            autosuggestKey: 0, // incrementa pra forçar o vue-autosuggest a recriar com o valor certo (ex: ao clicar numa dica de coleção)
            selected: "",

            // UI
            sheet: false,
            multiple: true,
            flat: false,
            panel: [0, 1, 2, 3, 4, 5],
            painelMercado: 0,
            painelCategoria: 0,
            painelSegmento: 0,
            painelAno: 0,
            isMobile: false,
            debounceTimer: null,
            informacoes: {},


        };
    },

    mounted() {
        // Carrega ebsa/token somente depois que as propriedades de data() já existem.
        // Antes, getLocal() era executado dentro de data() e o `ebsa: false`
        // retornado logo depois sobrescrevia o valor recuperado do localStorage.
        this.getLocal();

        this.isMobile = window.innerWidth <= 768;
        window.addEventListener('resize', this.checkMobile);

        // Preconnect pro domínio das capas (conteudos.editoradobrasil.com.br) - adianta
        // DNS lookup + handshake TLS antes do navegador precisar baixar as imagens dos
        // cards, evitando que cada uma das 24 capas pague esse custo individualmente.
        const dominioCapas = 'https://conteudos.editoradobrasil.com.br';
        if (!document.querySelector(`link[rel="preconnect"][href="${dominioCapas}"]`)) {
            const link = document.createElement('link');
            link.rel = 'preconnect';
            link.href = dominioCapas;
            link.crossOrigin = 'anonymous';
            document.head.appendChild(link);

            // dns-prefetch como fallback pra navegadores/condições onde o preconnect não
            // se completa a tempo (ainda adianta a resolução DNS, que é parte do custo)
            const linkDns = document.createElement('link');
            linkDns.rel = 'dns-prefetch';
            linkDns.href = dominioCapas;
            document.head.appendChild(linkDns);
        }

        this.getFiltrosDisponiveis();
        this.getLivros();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },

    watch: {
        selected(val) {
            if (val == "") return;
            this.abrirFlipbook(val.arquivo, val.id, val.complemento);
        },
        // Watchers para multi-seleção — dispara a busca ao marcar/desmarcar qualquer opção
        categoriasSelecionadas() { this.filterMaster(); },
        segmentosSelecionados() {
            
            if (this.segmentosSelecionados.includes('Ensino Médio')) this.atualizarDisciplinasEM();
            this.filterMaster();
        },
        anosSelecionados() {
            // Varal de Letras só existe pra EI + 5 anos; se desmarcar 5 anos, remove do que já estava selecionado
            if (!this.anosSelecionados.includes('EI V3 - 5 ANOS')) {
                const idx = this.materiaisSelecionados.indexOf('Varal de Letras');
                if (idx >= 0) this.materiaisSelecionados.splice(idx, 1);
            }
            
            const anosSemVersao = ['2º ANO', '3º ANO', '4º ANO', '5º ANO'];
            if (anosSemVersao.some(a => this.anosSelecionados.includes(a))) {
                this.versoesSelecionadas = [];
            }
            this.filterMaster();
        },
        versoesSelecionadas()    { this.filterMaster(); },
        anoProgramaSelecionados() { this.filterMaster(); },
        litAnoSerieSelecionados()      { this.filterMaster(); },
        litGeneroTextualSelecionados() { this.filterMaster(); },
        litTemaSelecionados()          { this.filterMaster(); },
        litDataEspecialSelecionados()  { this.filterMaster(); },
        litPaginasSelecionados()       { this.filterMaster(); },
        litConteudosSelecionados()     { this.filterMaster(); },
        autoresAdicionados()           { this.filterMaster(); },
        materiaisSelecionados() {
           
            if (this.materiaisSelecionados.includes('Livro do Professor (EM)')) {
                const escondidasProfessor = ['INTEGRADO', 'Língua Inglesa', 'Ciências', 'Apostila'];
                this.disciplinasEMSelecionadas = this.disciplinasEMSelecionadas
                    .filter(d => !escondidasProfessor.includes(d));
               
                this.modalidadesEMSelecionadas = [];
                this.seriesEMSelecionadas = [];
            }
            
            if (this.materiaisSelecionados.includes('Livro do Aluno (EM)')) {
                const permitidasAluno = ['Língua Espanhola', 'Produção de Texto'];
                this.disciplinasEMSelecionadas = this.disciplinasEMSelecionadas
                    .filter(d => permitidasAluno.includes(d));
            }
            this.filterMaster();
        },
        componentesSelecionados() { this.filterMaster(); },
        apoioSelecionados() { this.filterMaster(); },
        periodosSelecionados() { this.filterMaster(); },
        materiaisLiteraturaSelecionados() { this.filterMaster(); },
        colecoesDidaticosSelecionados() { this.filterMaster(); },
        tiposPeriodoSelecionados() { this.filterMaster(); },
        modalidadesEMSelecionadas() {
           
            const chavesValidas = this.modalidadesEMSelecionadas.flatMap(m => this.seriesParaModalidade(m).map(item => item.valor));
            this.seriesEMSelecionadas = this.seriesEMSelecionadas.filter(v => chavesValidas.includes(v));
            this.filterMaster();
        },
        seriesEMSelecionadas() {
            this.filterMaster();
        },
        disciplinasEMSelecionadas() { this.filterMaster(); },
    },

    computed: {
        filteredOptions() {
            if (!this.query || this.query.length < 3) return [{ data: [] }];
            const q = this.normalizar(this.query);

           
            const nomesDicas = (this.colecoes || [])
                .filter(c => c && this.normalizar(c).indexOf(q) > -1)
                .slice(0, 4);

            const grupoDicas = nomesDicas.length > 0
                ? [{ id: 'dicas-grupo', tipo: 'colecao-grupo', dicas: nomesDicas }]
                : [];

            const livros = this.suggestions[0].data
                .filter(o => this.normalizar(o.titulo).indexOf(q) > -1)
                .slice(0, 10);

            return [{ data: [...grupoDicas, ...livros] }];
        },

        // Nível 2 - Categorias sempre vêm fixas do GetFiltros, ordem alfabética
        categoriasDisponiveis() {
            return [...this.categoriasTodas].sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },

        // Nível 3 - Segmentos em ordem alfabética
        segmentosDisponiveis() {
            return [...this.segmentosTodos].sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },


        // Nível 4 - Anos em ordem lógica (1º, 2º, 3º... antes de EM, Volume único etc)
        anosDisponiveis() {
            return [...this.anosTodos].sort((a, b) => this.compararAno(a, b));
        }
    },

    methods: {
        // Monta a lista de Anos a exibir no filtro. Para Educação Infantil e Ensino Fundamental I
        // (dentro de Sistema de Ensino), restringe e traduz os valores crus do banco para um
        // label amigável. Para os demais segmentos, mantém o comportamento padrão (valor = label).
        anosParaExibir(cat, seg, mercado) {
            if (cat === 'Sistema de Ensino' && seg === 'Educação Infantil' && mercado === 'publico') {
                return [
                    { label: '1 ano (Berçário)', valor: 'EI  IV' },
                    { label: '2 anos',           valor: 'EI VI - 2 ANOS' },
                    { label: '3 anos',           valor: 'EI V1 - 3 ANOS' },
                    { label: '4 anos',           valor: 'EI V2 - 4 ANOS' },
                    { label: '5 anos',           valor: 'EI V3 - 5 ANOS' },
                ];
            }
            if (cat === 'Sistema de Ensino' && seg === 'Educação Infantil') {
                return [
                    { label: '2 anos',           valor: 'EI VI - 2 ANOS' },
                    { label: '3 anos',           valor: 'EI V1 - 3 ANOS' },
                    { label: '4 anos',           valor: 'EI V2 - 4 ANOS' },
                    { label: '5 anos',           valor: 'EI V3 - 5 ANOS' },
                ];
            }
            if (cat === 'Sistema de Ensino' && seg === 'Ensino Fundamental I') {
                return [
                    { label: '1º ano', valor: '1º ANO' },
                    { label: '2º ano', valor: '2º ANO' },
                    { label: '3º ano', valor: '3º ANO' },
                    { label: '4º ano', valor: '4º ANO' },
                    { label: '5º ano', valor: '5º ANO' },
                ];
            }
            
            if (cat === 'Sistema de Ensino' && seg === 'Ensino Fundamental II' && mercado === 'privado') {
                return [
                    { label: '6º ano', valor: '6º ANO' },
                    { label: '7º ano', valor: '7º ANO' },
                    { label: '8º ano', valor: '8º ANO' },
                    { label: '9º ano', valor: '9º ANO' },
                    { label: 'Volume Único', valor: 'VOL ÚNICO,VOL ÚNICO F2' },
                ];
            }
            if (cat === 'Sistema de Ensino' && seg === 'Ensino Fundamental II') {
                return [
                    { label: '6º ano', valor: '6º ANO' },
                    { label: '7º ano', valor: '7º ANO' },
                    { label: '8º ano', valor: '8º ANO' },
                    { label: '9º ano', valor: '9º ANO' },
                ];
            }
            if (cat === 'Didáticos' && seg === 'Educação Infantil' && mercado === 'publico') {
                return [
                    { label: 'Berçário', valor: 'EI  IV' },
                    { label: '2 anos',   valor: 'EI VI - 2 ANOS' },
                    { label: '3 anos',   valor: 'EI V1 - 3 ANOS' },
                    { label: '4 anos',   valor: 'EI V2 - 4 ANOS' },
                    { label: '5 anos',   valor: 'EI V3 - 5 ANOS' },
                ];
            }
            if (cat === 'Didáticos' && seg === 'Educação Infantil') {
                return [
                    { label: '2 anos', valor: 'EI VI - 2 ANOS' },
                    { label: '3 anos', valor: 'EI V1 - 3 ANOS' },
                    { label: '4 anos', valor: 'EI V2 - 4 ANOS' },
                    { label: '5 anos', valor: 'EI V3 - 5 ANOS' },
                ];
            }
            if (cat === 'Didáticos' && seg === 'Ensino Fundamental I') {
                // Opção única que cobre a faixa toda (não se separa em 5 checkboxes aqui)
                return [
                    { label: '1º ao 5º ano', valor: '1º ANO,2º ANO,3º ANO,4º ANO,5º ANO' },
                ];
            }
            if (cat === 'Didáticos' && seg === 'Ensino Fundamental II') {
                return [
                    { label: '6º ao 9º ano', valor: '6º ANO,7º ANO,8º ANO,9º ANO,VOL ÚNICO F2' },
                ];
            }
            if (cat === 'Didáticos' && seg === 'Ensino Médio') {
                
                return [
                    { label: 'Volume único',   valor: 'VOL ÚNICO,VOL ÚNICO EM' },
                    { label: '1ª à 3ª série',  valor: 'EM 1º,EM 2º,EM 3º,VOLUME 1,VOLUME 2,VOLUME 3' },
                ];
            }
            if (cat === 'Apoio' && seg === 'Educação Infantil') {
                
                return [
                    { label: '2 anos', valor: 'EI VI - 2 ANOS' },
                    { label: '3 anos', valor: 'EI V1 - 3 ANOS' },
                    { label: '4 anos', valor: 'EI V2 - 4 ANOS' },
                    { label: '5 anos', valor: 'EI V3 - 5 ANOS' },
                ];
            }
            if (cat === 'Apoio' && seg === 'Ensino Fundamental I') {
                return [
                    { label: '1º ao 5º ano', valor: '1º ANO,2º ANO,3º ANO,4º ANO,5º ANO' },
                ];
            }
            if (cat === 'Apoio' && seg === 'Ensino Fundamental II') {
                return [
                    { label: '6º ao 9º ano', valor: '6º ANO,7º ANO,8º ANO,9º ANO,VOL ÚNICO F2' },
                ];
            }
            if (cat === 'Apoio' && seg === 'Ensino Médio') {
                // Junta Ensino Médio, Ensino Médio - Interação e Novo Ensino Médio Digital
                // num único segmento. Valores confirmados: 'VOL ÚNICO EM' (Itinerário Formativo).
                // EM 1º/2º/3º incluídos por analogia com os outros segmentos de Apoio - validar
                // se alguma coleção nova usa esses valores.
                // VOLUME 1/2/3 adicionado 
                // Produção de Texto - Volume 1" (nm_serie='VOLUME 1') não aparecia porque esse
                // valor nunca era enviado no parâmetro 'ano' pra Apoio + Ensino Médio, mesmo com
                // o bypass de Segmento já corrigido pra reconhecer VOLUME 1/2/3 no backend.
                return [
                    { label: '1ª à 3ª série', valor: 'VOL ÚNICO EM,EM 1º,EM 2º,EM 3º,VOLUME 1,VOLUME 2,VOLUME 3' },
                ];
            }
            if (cat === 'Literatura') {
                // Literatura usa os Anos que realmente existem combinados com o Segmento
                // marcado (sem isso, podia aparecer Ano sem nenhum livro relacionado)
                const chave = `${mercado}|${seg}`;
                const anos = (this.literaturaSegmentoCache[chave] && this.literaturaSegmentoCache[chave].anos) || [];
                return [...anos]
                    .sort((a, b) => this.compararAno(a, b))
                    .map(ano => ({ label: ano, valor: ano }));
            }
            // Comportamento padrão: usa a lista crua vinda do banco, sem tradução
            return this.anosDisponiveis.map(ano => ({ label: ano, valor: ano }));
        },

        
        literaturaAnoSerieGrupos() {
            return [
                { titulo: 'Educação Infantil', itens: [
                   
                    { chave: 'EI_0_3', label: '0 a 3 anos', segmento: 'Educação Infantil', anos: ['EI VI - 2 ANOS', 'EI V1 - 3 ANOS', 'VOL ÚNICO', 'VOL ÚNICO EI'] },
                    { chave: 'EI_4_5', label: '4 e 5 anos', segmento: 'Educação Infantil', anos: ['EI V2 - 4 ANOS', 'EI V3 - 5 ANOS', 'VOL ÚNICO', 'VOL ÚNICO EI'] },
                ]},
                { titulo: 'Anos Iniciais', itens: [
                    { chave: 'EF1_1_3', label: '1º ao 3º anos', segmento: 'Ensino Fundamental I', anos: ['1º ANO', '2º ANO', '3º ANO'] },
                    { chave: 'EF1_4_5', label: '4º e 5º anos', segmento: 'Ensino Fundamental I', anos: ['4º ANO', '5º ANO'] },
                ]},
                { titulo: 'Anos Finais', itens: [
                    { chave: 'EF2_6_7', label: '6º e 7º anos', segmento: 'Ensino Fundamental II', anos: ['6º ANO', '7º ANO'] },
                    { chave: 'EF2_8_9', label: '8º e 9º anos', segmento: 'Ensino Fundamental II', anos: ['8º ANO', '9º ANO'] },
                ]},
                { titulo: 'Ensino Médio', itens: [
                    { chave: 'EM_1_3', label: '1ª à 3ª série', segmento: 'Ensino Médio', anos: ['EM 1º', 'EM 2º', 'EM 3º'] },
                ]},
            ];
        },
        literaturaAnoSerieItensFlat() {
            return this.literaturaAnoSerieGrupos().flatMap(g => g.itens);
        },
        selecionarLitAnoSerie(chave) {
            const idx = this.litAnoSerieSelecionados.indexOf(chave);
            if (idx >= 0) this.litAnoSerieSelecionados.splice(idx, 1);
            else this.litAnoSerieSelecionados.push(chave);
        },

        // Conteúdos disciplinares (Literatura) - mapa label -> materia, mesmo padrão dos
        // Componentes Curriculares de Didáticos
        mapaConteudosLiteratura() {
            return {
                'Ciências': ['CIENCIAS'], 'História': ['HISTORIA'], 'Geografia': ['GEOGRAFIA'],
                'Literatura': ['LITERATURA'], 'Arte': ['ARTES'], 'Filosofia': ['FILOSOFIA'],
                'Língua portuguesa': ['PORTUGUES'], 'Sociologia': ['SOCIOLOGIA'],
                'Biologia': ['BIOLOGIA'], 'Educação Física': ['EDUCACAO FISICA'],
                'Língua inglesa': ['INGLES'], 'Matemática': ['MATEMATICA'],
            };
        },

        // Gêneros textuais (Literatura) - valores confirmados via query, exceto Lenda e
        // Provérbios (pendência: zero livro encontrado com esses dois generos no banco hoje)
        listaGenerosTextuaisLiteratura() {
            return ['Adivinha', 'Conto', 'Cordel', 'Crônica', 'Diário', 'História em Quadrinhos',
                'Informativo', 'Lenda', 'Livro de imagem', 'Novela', 'Poema', 'Provérbios',
                'Romance', 'Teatro', 'Trava-língua'];
        },

        // Data especial (Literatura) - mapa label -> valor real no banco (tabela
        // ebsa.data_especial). 
        mapaDataEspecialLiteratura() {
            return {
                'Consciência Negra': 'DIA NACIONAL DA CONSCIÊNCIA NEGRA',
                'Dia das Crianças': 'DIA DAS CRIANÇAS',
                'Dia da Família': 'DIA DAS MÃES',
                'Festa Junina': 'FESTA JUNINA',
                'Folclore': 'DIA DO FOLCLORE',
                'Independência do Brasil': 'INDEPENDÊNCIA DO BRASIL',
                'Natal': 'NATAL',
                'Povos Originários': 'DIA INTERNACIONAL DOS POVOS INDÍGENAS',
            };
        },

        // Tema (Literatura) - mapa label -> valor real no banco (tabela ebsa.assunto).
        // Pendência: Emoções e Projeto de Vida não têm valor correspondente hoje (zero resultado).
        mapaTemaLiteratura() {
            return {
                'Amizade': 'AMIZADE', 'Ciências': 'CIÊNCIA', 'Diversidade': 'DIVERSIDADE',
                'Emoções': 'EMOÇÕES', 'Família': 'FAMÍLIA', 'Fantasia': 'FANTASIA',
                'Folclore': 'FOLCLORE', 'Inclusão': 'INCLUSÃO', 'Meio ambiente': 'MEIO AMBIENTE',
                'Projeto de Vida': 'PROJETO DE VIDA', 'Valores': 'VALORES',
            };
        },

        // Número de páginas (Literatura) - faixas mapeadas pro backend (ranges fixos)
        listaPaginasLiteratura() {
            return [
                { label: 'Menos de 32 páginas', valor: '0-31' },
                { label: '32 a 48 páginas', valor: '32-48' },
                { label: '49 a 72 páginas', valor: '49-72' },
                { label: '73 a 104 páginas', valor: '73-104' },
                { label: '105 a 152 páginas', valor: '105-152' },
                { label: 'Mais de 152 páginas', valor: '153+' },
            ];
        },

        selecionarLitGeneroTextual(valor) {
            const idx = this.litGeneroTextualSelecionados.indexOf(valor);
            if (idx >= 0) this.litGeneroTextualSelecionados.splice(idx, 1);
            else this.litGeneroTextualSelecionados.push(valor);
        },
        selecionarLitTema(valor) {
            const idx = this.litTemaSelecionados.indexOf(valor);
            if (idx >= 0) this.litTemaSelecionados.splice(idx, 1);
            else this.litTemaSelecionados.push(valor);
        },
        selecionarLitDataEspecial(valor) {
            const idx = this.litDataEspecialSelecionados.indexOf(valor);
            if (idx >= 0) this.litDataEspecialSelecionados.splice(idx, 1);
            else this.litDataEspecialSelecionados.push(valor);
        },
        selecionarLitPaginas(valor) {
            const idx = this.litPaginasSelecionados.indexOf(valor);
            if (idx >= 0) this.litPaginasSelecionados.splice(idx, 1);
            else this.litPaginasSelecionados.push(valor);
        },
        selecionarLitConteudo(valor) {
            const idx = this.litConteudosSelecionados.indexOf(valor);
            if (idx >= 0) this.litConteudosSelecionados.splice(idx, 1);
            else this.litConteudosSelecionados.push(valor);
        },

        
        // anos 2025/2026 não devem aparecer lá); Mercado Privado continua igual.
        temSubFiltroAnoPrograma(cat, seg, mercado) {
            const segmentosComAnoPrograma = ['Educação Infantil', 'Ensino Fundamental I'];
            return cat === 'Sistema de Ensino' && segmentosComAnoPrograma.includes(seg) && mercado !== 'publico';
        },

       
        labelSegmento(seg) {
            if (seg === 'Ensino Fundamental I') return 'Anos Iniciais';
            if (seg === 'Ensino Fundamental II') return 'Anos Finais';
            return seg;
        },

        temSubFiltroVersao(cat, seg, mercado) {
            const segmentosComVersao = ['Educação Infantil', 'Ensino Fundamental I'];
            if (!(mercado === 'privado' && cat === 'Sistema de Ensino' && segmentosComVersao.includes(seg))) {
                return false;
            }
            
            if (seg === 'Ensino Fundamental I') {
                const anosSemVersao = ['2º ANO', '3º ANO', '4º ANO', '5º ANO'];
                const temAnoSemVersao = anosSemVersao.some(a => this.anosSelecionados.includes(a));
                if (temAnoSemVersao) return false;
            }
            return true;
        },

        
        temSubFiltroBimestre(cat, seg, mercado) {
            const segmentosComBimestre = [];
            return mercado === 'publico' && cat === 'Sistema de Ensino' && segmentosComBimestre.includes(seg);
        },

        // Versão A/B (Área Pública + Ensino Fundamental I) só aparece depois de marcar "1º ano"
        // especificamente - diferente do Privado, onde aparece antes do Ano, sem depender dele.
        temSubFiltroVersaoPublico(cat, seg, mercado) {
            return mercado === 'publico' && cat === 'Sistema de Ensino' && seg === 'Ensino Fundamental I'
                && this.anosSelecionados.includes('1º ANO');
        },

        
        temSubFiltroMaterial(cat, seg) {
            const segmentosComMaterial = ['Educação Infantil', 'Ensino Fundamental I'];
            if (seg === 'Ensino Fundamental II') return false;
            return cat === 'Sistema de Ensino' && segmentosComMaterial.includes(seg);
        },

        // Componentes Curriculares aparece só uma vez na árvore - embaixo do último segmento
        // da lista (varia por mercado: Ensino Médio no Privado, Ensino Fundamental II no Público).
        temSubFiltroComponentes(cat, seg, mercado) {
            if (cat !== 'Didáticos') return false;
            const lista = this.segmentosDisponiveisPara(cat, mercado);
            return seg === lista[lista.length - 1];
        },

        // Verifica se algum Ano/Idade/Série foi marcado em QUALQUER segmento de Didáticos -
        // usado pra abrir Componentes Curriculares (que agora some só uma vez, no último segmento,
        // mas precisa abrir independente de qual dos segmentos teve o Ano marcado).
        algumAnoSelecionadoEmDidaticos(mercado) {
            return this.segmentosDisponiveisPara('Didáticos', mercado)
                .some(seg => this.anoSelecionadoParaSegmento('Didáticos', seg, mercado));
        },

        // Categoria de apoio aparece só uma vez na árvore - embaixo do último segmento da lista
        // (varia por mercado: Novo Ensino Médio Digital no Privado, Ensino Fundamental II no Público).
        temSubFiltroApoio(cat, seg, mercado) {
            if (cat !== 'Apoio') return false;
            const lista = this.segmentosDisponiveisPara(cat, mercado);
            return seg === lista[lista.length - 1];
        },

        // Dentro de "Didáticos" e "Apoio", o Segmento não é mais um checkbox clicável - é só um
        // título organizando os filtros de idade/série abaixo dele (que antes ficavam sempre
        // visíveis assim que a Categoria era marcada).
        segmentoComoTitulo(cat) {
            return cat === 'Didáticos' || cat === 'Apoio';
        },

       
        grupoExpandido(chave) {
            return this.gruposExpandidos.includes(chave);
        },
        toggleGrupoExpandido(chave) {
            const idx = this.gruposExpandidos.indexOf(chave);
            if (idx >= 0) this.gruposExpandidos.splice(idx, 1);
            else this.gruposExpandidos.push(chave);
        },
        // Mantidos como wrappers finos por compatibilidade com o restante do código que já
        // chamava esses nomes (Segmento como título - Apoio/Didáticos).
        segmentoExpandido(cat, seg, mercado) {
            return this.grupoExpandido(`${cat}|${seg}|${mercado}`);
        },
        toggleSegmentoExpandido(cat, seg, mercado) {
            this.toggleGrupoExpandido(`${cat}|${seg}|${mercado}`);
        },

        // Verifica se o usuário já marcou algum item de Ano/Idade/Série pertencente a esse
        // segmento específico - usado pra só abrir Componentes Curriculares depois disso.
        anoSelecionadoParaSegmento(cat, seg, mercado) {
            return this.anosParaExibir(cat, seg, mercado).some(item => this.anosSelecionados.includes(item.valor));
        },

        
        mapaComponentes(mercado) {
            if (mercado === 'publico') {
                return {
                    'Língua Portuguesa': ['PORTUGUES'],
                    'Matemática':         ['MATEMATICA'],
                    'Ciências':           ['CIENCIAS', 'CIÊNCIAS DA NATUREZA'],                   
                    'História':           ['HISTORIA'],
                    'Geografia':          ['GEOGRAFIA'],
                    'Arte':               ['ARTES'],
                    'Língua Espanhola':   ['ESPANHOL'],
                    'Língua Inglesa':     ['INGLES'],
                    'Projeto de Vida':    ['PROJETO DE VIDA'],
                    'Física':             ['FISICA'],
                    'Química':            ['QUIMICA'],
                    'Biologia':           ['BIOLOGIA'],
                    'Filosofia':          ['FILOSOFIA'],
                    'Sociologia':         ['SOCIOLOGIA'],
                    'Educação Física':    ['EDUCACAO FISICA'],
                    'Educação Midiática': [], // Pendência: nenhum valor de materia encontrado ainda
                    'Ensino Religioso':   ['ENS RELIGIOSO'],
                    'Livro integrado':    ['INTEGRADO', 'INTEGRADA', 'HIST E GEO'],
                };
            }
            return {
                'Língua Portuguesa': ['PORTUGUES'],
                'Matemática':         ['MATEMATICA'],
                'Ciências':           ['CIENCIAS', 'CIÊNCIAS DA NATUREZA'],
                'História':           ['HISTORIA'],
                'Geografia':          ['GEOGRAFIA'],
                'Arte':               ['ARTES'],
                'Língua Inglesa':     ['INGLES'],
                'Língua Espanhola':   ['ESPANHOL'],
                'Projeto de Vida':    ['PROJETO DE VIDA'],
                'Física':             ['FISICA'],
                'Química':            ['QUIMICA'],
                'Biologia':           ['BIOLOGIA'],
                'Filosofia':          ['FILOSOFIA'],
                'Sociologia':         ['SOCIOLOGIA'],
                'Educação Física':    ['EDUCACAO FISICA'],
                'Educação Digital':   ['EDUCAÇÃO DIGITAL'],
                'Livro Integrado':    ['INTEGRADO', 'INTEGRADA', 'HIST E GEO'],
            };
        },

       
        componentesDisponiveis(seg, mercado) {
            const todos = Object.keys(this.mapaComponentes(mercado));
            const escondidosPublicoPorSegmento = {
                'Ensino Fundamental I': [
                    'Projeto de Vida', 'Física', 'Química', 'Biologia',
                    'Filosofia', 'Sociologia', 'Educação Física', 'Educação Midiática'
                ],
                'Ensino Fundamental II': [
                    'Projeto de Vida', 'Física', 'Química', 'Biologia',
                    'Filosofia', 'Sociologia', 'Educação Física',
                    'Educação Midiática', 'Livro integrado'
                ],
            };
           
            const escondidosPrivadoPorSegmento = {
                'Ensino Fundamental I': [
                    'Física', 'Química', 'Biologia', 'Filosofia',
                    'Sociologia', 'Educação Física', 'Educação Digital', 'Projeto de Vida'
                ],
                'Ensino Fundamental II': [
                    'Física', 'Química', 'Biologia', 'Filosofia',
                    'Sociologia', 'Educação Física', 'Educação Digital'
                ],
            };
            const escondidos = mercado === 'publico'
                ? (escondidosPublicoPorSegmento[seg] || [])
                : (escondidosPrivadoPorSegmento[seg] || []);
            return todos.filter(c => !escondidos.includes(c)).sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },

        // Sub-filtro (Didáticos + EI/EFI/EFII/EM): Componentes Curriculares - toggle multi-seleção
        selecionarComponente(valor) {
            const idx = this.componentesSelecionados.indexOf(valor);
            if (idx >= 0) this.componentesSelecionados.splice(idx, 1);
            else this.componentesSelecionados.push(valor);
        },

        // Sub-filtro (Didáticos + Ensino Fundamental I/II): Coleções (título) - toggle multi-seleção
        selecionarColecaoDidatico(valor) {
            const idx = this.colecoesDidaticosSelecionados.indexOf(valor);
            if (idx >= 0) this.colecoesDidaticosSelecionados.splice(idx, 1);
            else this.colecoesDidaticosSelecionados.push(valor);
        },

        // Mapa dos itens de "Categoria de apoio" que são identificados pelo campo materia
        // (igual aos Componentes Curriculares - comparação exata e direta no banco).
        // "Gramática" só existe na lista do Público.
        mapaApoioMateria(mercado) {
            const base = {
                'Educação Financeira':       ['EDUCACAO FINANCEIRA'],
                'Educação Sócio emocional':   ['SOCIOEMOCIONAL'],
                'Língua Inglesa':             ['INGLES'],
                'Língua Espanhola':           ['ESPANHOL'],
                'Arte':                       ['ARTES'],
                'Ética e Cidadania':          ['ETICA E CIDADANIA', 'ENS RELIGIOSO'],
                'Caligrafia':                 ['CALIGRAFIA'],
            };
            if (mercado === 'publico') {
                base['Gramática'] = ['GRAMATICA'];
            }
            return base;
        },

        // Itens de "Categoria de apoio" que só existem no título do livro (sem coluna própria,
        // mesmo mecanismo do filtro de Material - por isso usam a mesma chave 'material' na API,
        // bypassando a regra de coleção da Categoria, podendo cruzar com outras categorias)
        listaApoioPorTitulo() {
            return ['Solução Bilíngue', 'Caderno de Atividades', 'Raciocínio e Cálculo Mental', 'Livro de Bolso', 'Educação Ambiental', 'Produção de Texto'];
        },

        
        apoioDisponiveis(seg, mercado) {
            const porMateria = Object.keys(this.mapaApoioMateria(mercado));
            const porTitulo = this.listaApoioPorTitulo().filter(i => i !== 'Educação Ambiental' && i !== 'Produção de Texto');
           
            // Inserir Produção de Texto logo após Arte
            const idxArte = porMateria.indexOf('Arte');
            if (idxArte >= 0) porMateria.splice(idxArte + 1, 0, 'Produção de Texto');
            const todos = [...porMateria, ...porTitulo];
            
            const somenteEF2Marcado = this.segmentosSelecionados.length === 1
                && this.segmentosSelecionados[0] === 'Ensino Fundamental II';
           
            if (mercado === 'privado' && somenteEF2Marcado) {
                return todos.filter(a => a !== 'Caligrafia').sort((a, b) => a.localeCompare(b, 'pt-BR'));
            }
            return todos.sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },

        // Sub-filtro (Apoio + EI/EFI/EFII/EM): Categoria de apoio - toggle multi-seleção
        selecionarApoio(valor) {
            const idx = this.apoioSelecionados.indexOf(valor);
            if (idx >= 0) this.apoioSelecionados.splice(idx, 1);
            else this.apoioSelecionados.push(valor);
        },

        // Título exibido acima do nível de Ano, varia por segmento (idade pra EI, ano pros demais).
        // Retorna null pros segmentos que não têm lista de Ano customizada (mantém comportamento padrão).
        tituloNivelAno(cat, seg) {
            if (cat === 'Literatura') return 'Anos';
            if (cat !== 'Sistema de Ensino') return null;
            if (seg === 'Educação Infantil') return 'Escolha a idade';
            if (seg === 'Ensino Fundamental I' || seg === 'Ensino Fundamental II') return 'Escolha do ano';
            return null;
        },

        // Lista de Segmentos a exibir dentro de cada Categoria. "Sistema de Ensino" e "Didáticos"
        // têm uma lista curada (confirmada com dados reais); as demais categorias (Apoio,
        // Literatura) ainda não foram mapeadas, então mostram a lista crua vinda do banco.
        // Em "Área Pública" + "Sistema de Ensino", os 3 segmentos de Ensino Médio ficam ocultos
        // (diferente de Mercado Privado, onde têm livros reais na coleção Série Brasil).
        segmentosDisponiveisPara(cat, mercado) {
            // Literatura usa os Segmentos que realmente existem nos livros de Literatura,
            // buscados dinamicamente da API e escopados por mercado (não é uma lista curada manualmente)
            if (cat === 'Literatura') {
                const segmentos = (this.literaturaCache[mercado] && this.literaturaCache[mercado].segmentos) || [];
                return [...segmentos].sort((a, b) => a.localeCompare(b, 'pt-BR'));
            }
            const listasCuradas = {
                'Sistema de Ensino': mercado === 'publico'
                    ? ['Educação Infantil', 'Ensino Fundamental I', 'Ensino Fundamental II']
                    : ['Educação Infantil', 'Ensino Fundamental I', 'Ensino Fundamental II', 'Ensino Médio'],
                'Didáticos': mercado === 'publico'
                    ? ['Educação Infantil', 'Ensino Fundamental I', 'Ensino Fundamental II']
                    : ['Educação Infantil', 'Ensino Fundamental I', 'Ensino Fundamental II', 'Ensino Médio'],
                'Apoio': mercado === 'publico'
                    ? ['Educação Infantil', 'Ensino Fundamental I', 'Ensino Fundamental II']
                    : ['Educação Infantil', 'Ensino Fundamental I', 'Ensino Fundamental II', 'Ensino Médio'],
            };
            if (listasCuradas[cat]) {
                return this.segmentosDisponiveis.filter(seg => listasCuradas[cat].includes(seg));
            }
            return this.segmentosDisponiveis;
        },

        // Define se o segmento deve mostrar o sub-filtro de Ano. Os 3 segmentos de Ensino Médio
        // ficam ocultos por enquanto, até confirmarmos com o time de negócio como mapear a
        // Modalidade (2 anos / 2 anos e meio / 3 anos) — o segmento em si continua selecionável.
        temSubFiltroAno(cat, seg) {
            const semSubFiltroAno = ['Ensino Médio'];
            return !(cat === 'Sistema de Ensino' && semSubFiltroAno.includes(seg));
        },

        
        labelVersao(versao) {
            return versao === 'A' ? 'VERSÃO A - BASTÃO' : 'VERSÃO B - CURSIVA';
        },

        
        temSubFiltroModalidadeEM(cat, seg, mercado) {
            return cat === 'Sistema de Ensino' && seg === 'Ensino Médio' && mercado === 'privado';
        },

        // Séries de cada Modalidade, mapeadas pra chave usada pelo backend (ModalidadeEMIsbns
        // no FlipbookRepository) - baseado em número de Volume/Livro, não em campo de série.
        seriesParaModalidade(modalidade) {
            const mapa = {
                '3 anos': [
                    { label: '1ª série', valor: '3ANOS_1' },
                    { label: '2ª série', valor: '3ANOS_2' },
                    { label: '3ª série', valor: '3ANOS_3' },
                ],
                '2 anos e meio': [
                    { label: '1ª série', valor: '2E5ANOS_1' },
                    { label: '2ª série', valor: '2E5ANOS_2' },
                    { label: '3ª série', valor: '2E5ANOS_3' },
                ],
                '2 anos': [
                    { label: '1ª série', valor: '2ANOS_1' },
                    { label: '2ª série', valor: '2ANOS_2' },
                    { label: '3ª série', valor: '2ANOS_3' },
                ],
            };
            return mapa[modalidade] || [];
        },

        // Chaves de Modalidade+Série que realmente vão pro backend agora - extraído daqui pra
        // ser usado tanto na montagem dos parâmetros da busca quanto no sub-filtro de
        // Disciplinas (que precisa saber exatamente esse mesmo recorte pra buscar as
        // disciplinas certas via GetFiltros).
        chavesModalidadeEMParaEnviar() {
            return this.modalidadesEMSelecionadas.flatMap(modalidade => {
                const chavesDaModalidade = this.seriesParaModalidade(modalidade).map(item => item.valor);
                const seriesMarcadas = chavesDaModalidade.filter(v => this.seriesEMSelecionadas.includes(v));
                return seriesMarcadas.length > 0 ? seriesMarcadas : chavesDaModalidade;
            });
        },

        // Monta a lista de materiais disponíveis de acordo com o Segmento e o Mercado (e, no caso
        // do Varal de Letras, também a Idade selecionada — só existe para EI com 5 anos)
        materiaisDisponiveisPara(seg, mercado) {
            const comuns = ['Caderno da Família', 'Literaturas', 'Cartazes'];

            if (seg === 'Educação Infantil' && mercado === 'publico') {
                // Pendência: "Agenda" ainda não tem nenhum livro cadastrado no banco (zero
                // resultados na busca por título) - checkbox aparece mas não filtra nada ainda
                return ['Agenda', ...comuns];
            }

            if (seg === 'Educação Infantil') {
                const materiais = ['Diário da Criança', 'Livro de Atividades EI', ...comuns];
                if (this.anosSelecionados.includes('EI V3 - 5 ANOS')) {
                    materiais.push('Varal de Letras');
                }
                return materiais;
            }

            if (seg === 'Ensino Fundamental I' && mercado === 'publico') {
                return ['Agenda', 'Caderno da Família', 'Literaturas', 'Livro do professor'];
            }

            if (seg === 'Ensino Fundamental I') {
                return ['Diário de Bordo', 'Lição de Casa', ...comuns];
            }

           
            if (seg === 'Ensino Fundamental II' && mercado === 'privado') {
                return ['Livro do professor', 'Livro do Aluno'];
            }

            return comuns;
        },

        // Extrai o número inicial de uma string de ano/série para ordenação lógica
        // Ex: "1º ano" -> 1, "9º ano" -> 9, "Volume único" -> 999 (vai pro final)
        compararAno(a, b) {
            const numA = parseInt(a.match(/\d+/));
            const numB = parseInt(b.match(/\d+/));
            const valA = isNaN(numA) ? 999 : numA;
            const valB = isNaN(numB) ? 999 : numB;
            if (valA !== valB) return valA - valB;
            return a.localeCompare(b, 'pt-BR');
        },

        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },

        sair() {
            localStorage.clear();
            this.$router.push('/');
        },

        getLocal() {
            try {
                const storage = JSON.parse(localStorage.getItem("user"));
                this.ebsa = storage.ebsa;
                this.$parent.$root.$children[0].userName = storage.userName.split(" ")[0];
                this.token = storage.token;
            } catch (error) {
                alert("Entre com seu usuário e senha para acessar o conteúdo.");
                this.$router.push("/");
                console.log(error);
            }
        },

        // Monta a query string com os filtros e paginação atuais
        buildParams(pagina = 1, pageSize = PAGE_SIZE) {
            const params = new URLSearchParams();
            params.append('userGuid', this.token);
            params.append('page', pagina);
            params.append('pageSize', pageSize);

            // Nível 1 - Mercado: P = Privado | E,F,M = Área Pública (combina os dois se ambos marcados)
            const redesParaEnviar = [];
            if (this.mercadosSelecionados.includes('privado')) redesParaEnviar.push('P');
            if (this.mercadosSelecionados.includes('publico')) redesParaEnviar.push('E', 'F', 'M');
            if (redesParaEnviar.length > 0)
                params.append('rede', redesParaEnviar.join(','));

            // Nível 2 - Categoria (multi-seleção, separado por vírgula)
            if (this.categoriasSelecionadas.length > 0)
                params.append('categoria', this.categoriasSelecionadas.join(','));

            // Nível 3 - Segmento (multi-seleção, separado por vírgula) - combinado com os
            // Segmentos implícitos da árvore fixa de Ano/Série de Literatura.
            // "Ensino Médio" na UI representa 3 segmentos do banco: Ensino Médio,
            // Ensino Médio - Interação e Novo Ensino Médio Digital — expandidos aqui.
            const litItensSelecionados = this.litAnoSerieSelecionados
                .map(chave => this.literaturaAnoSerieItensFlat().find(i => i.chave === chave))
                .filter(Boolean);
            const litSegmentos = [...new Set(litItensSelecionados.map(i => i.segmento))];
            const segmentosParaEnviar = [...new Set([...this.segmentosSelecionados, ...litSegmentos])]
                .flatMap(s => s === 'Ensino Médio' && (this.categoriasSelecionadas.includes('Apoio') || this.categoriasSelecionadas.includes('Sistema de Ensino') || this.categoriasSelecionadas.includes('Didáticos'))
                    ? ['Ensino Médio', 'Ensino Médio - Interação', 'Novo Ensino Médio Digital']
                    : [s]);
            const segmentoCombinado = [...new Set(segmentosParaEnviar)];
            if (segmentoCombinado.length > 0)
                params.append('segmento', segmentoCombinado.join(','));

            // Sub-filtro (Sistema de Ensino + Educação Infantil) - Versão A/B
            if (this.versoesSelecionadas.length > 0)
                params.append('versao', this.versoesSelecionadas.join(','));

            // Sub-filtro (Sistema de Ensino + EI/EFI, Privado e Público) - Ano de Programa
            if (this.anoProgramaSelecionados.length > 0)
                params.append('anoPrograma', this.anoProgramaSelecionados.join(','));

            // Nível 4 - Ano (multi-seleção, separado por vírgula) - combinado com os Anos
            // implícitos da árvore fixa de Ano/Série de Literatura
            const litAnos = litItensSelecionados.flatMap(i => i.anos);
            const anoCombinado = [...new Set([...this.anosSelecionados, ...litAnos])];
            if (anoCombinado.length > 0)
                params.append('ano', anoCombinado.join(','));

            // Sub-filtro (Sistema de Ensino + EI/EFI) - Materiais disponíveis, combinado com os
            // itens de "Categoria de apoio" que são identificados por título (mesmo mecanismo)
            const apoioPorTitulo = this.apoioSelecionados.filter(label => this.listaApoioPorTitulo().includes(label));
            const materialCombinado = [...new Set([...this.materiaisSelecionados, ...apoioPorTitulo])];
            if (materialCombinado.length > 0)
                params.append('material', materialCombinado.join(','));

            // Sub-filtro (Sistema de Ensino + EI, Área Pública) - Bimestre/Trimestre.
            // Se o tipo está marcado mas nenhum período específico dele foi marcado, manda
            // todos os períodos daquele tipo (busca ampla); senão, manda só os marcados.
            const periodosParaEnviar = [];
            this.tiposPeriodoSelecionados.forEach(tipo => {
                const valoresDoTipo = this.periodosParaTipo(tipo).map(item => item.valor);
                const especificosMarcados = this.periodosSelecionados.filter(v => valoresDoTipo.includes(v));
                periodosParaEnviar.push(...(especificosMarcados.length > 0 ? especificosMarcados : valoresDoTipo));
            });
            if (periodosParaEnviar.length > 0)
                params.append('periodo', periodosParaEnviar.join(','));

            // Sub-filtro (Sistema de Ensino + Ensino Médio, Privado) - Modalidade do Versa.
           
            const seriesEMParaEnviar = this.chavesModalidadeEMParaEnviar();
            if (seriesEMParaEnviar.length > 0)
                params.append('modalidadeEM', seriesEMParaEnviar.join(','));

            const mapaComponentesCombinado = { ...this.mapaComponentes('privado'), ...this.mapaComponentes('publico') };
            const mapaApoioCombinado = { ...this.mapaApoioMateria('privado'), ...this.mapaApoioMateria('publico') };
            const mapaConteudosLit = this.mapaConteudosLiteratura();
           
            const materiasDosComponentes = this.componentesSelecionados
                .flatMap(label => mapaComponentesCombinado[label] || [label]);
            const materiasDoApoio = this.apoioSelecionados
                .flatMap(label => mapaApoioCombinado[label] || []);
            const materiasDaLiteratura = this.litConteudosSelecionados.flatMap(label => mapaConteudosLit[label] || []);
            const mapaDisciplinasEMCombinado = this.mapaDisciplinasEM();
            const materiasDasDisciplinasEM = this.disciplinasEMSelecionadas
                .flatMap(label => mapaDisciplinasEMCombinado[label] || [label]);
            const disciplinasCombinadas = [...new Set([...this.disciplinasAdicionadas, ...materiasDosComponentes, ...materiasDoApoio, ...materiasDaLiteratura, ...materiasDasDisciplinasEM])];
            if (disciplinasCombinadas.length > 0)
                params.append('disciplina', disciplinasCombinadas.join(','));

            // Filtros adicionais (Coleção, Autor) - combinado com os Materiais disponíveis de Literatura
            const colecaoCombinada = [...new Set([...this.colecoesAdicionadas, ...this.materiaisLiteraturaSelecionados, ...this.colecoesDidaticosSelecionados])];
            if (colecaoCombinada.length > 0)
                params.append('colecao', colecaoCombinada.join(','));
            if (this.autoresAdicionados.length === 1)
                params.append('autor', this.autoresAdicionados[0]);

            // Sub-filtros (Literatura): Gênero Textual, Tema, Data Especial, Páginas
            if (this.litGeneroTextualSelecionados.length > 0)
                params.append('generoTextual', this.litGeneroTextualSelecionados.join(','));
            if (this.litTemaSelecionados.length > 0) {
                const mapaTema = this.mapaTemaLiteratura();
                params.append('tema', this.litTemaSelecionados.map(label => mapaTema[label] || label).join(','));
            }
            if (this.litDataEspecialSelecionados.length > 0) {
                const mapaData = this.mapaDataEspecialLiteratura();
                params.append('dataEspecial', this.litDataEspecialSelecionados.map(label => mapaData[label] || label).join(','));
            }
            if (this.litPaginasSelecionados.length > 0)
                params.append('paginasFaixa', this.litPaginasSelecionados.join(','));

            if (this.query && this.query.length >= 3)
                params.append('busca', this.query);

            return params.toString();
        },

        // Carrega os valores de filtro disponíveis (TODOS os livros, sem paginação)
        async getFiltrosDisponiveis() {
            try {
                const res = await http.get('Flipbook/GetFiltros', {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + this.token
                    }
                });
                this.segmentosTodos  = res.data.segmentos   || [];
                this.disciplinas     = res.data.disciplinas || [];
                this.anosTodos        = res.data.anos        || [];
                this.colecoes        = res.data.colecoes    || [];
                this.autores         = res.data.autores     || [];
                this.categoriasTodas  = res.data.categorias  || [];
            } catch (err) {
                console.log('Erro ao carregar filtros', err);
            }
        },

        // Traduz o mercado selecionado pro valor de Rede esperado pela API (mesma regra usada no buildParams)
        redeParaMercado(mercado) {
            if (mercado === 'privado') return 'P';
            if (mercado === 'publico') return 'E,F,M';
            return null;
        },

        // Carrega as Coleções e Autores escopados só aos livros de Literatura, separado por
        // mercado (sob demanda, uma vez por mercado - fica em cache depois). Diferente do
        // getFiltrosDisponiveis() de cima, que é global pra todo o catálogo. Segmentos/Anos
        // de Literatura não dependem mais dessa chamada - viraram árvore fixa.
        async getFiltrosLiteratura(mercado) {
            if (this.literaturaCache[mercado]) return; // já carregou esse mercado, não busca de novo
            try {
                const res = await http.get('Flipbook/GetFiltros', {
                    params: { categoria: 'Literatura', rede: this.redeParaMercado(mercado) },
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + this.token
                    }
                });
                this.literaturaCache[mercado] = {
                    colecoes: (res.data.colecoes || []).filter(c => !!c),
                    autores: (res.data.autores || []).filter(a => !!a),
                };
            } catch (err) {
                console.log('Erro ao carregar Coleções/Autores de Literatura', err);
                this.literaturaCache[mercado] = { colecoes: [], autores: [] };
            }
        },

        // Lista de Coleções de Literatura pro mercado já selecionado (junta os mercados
        // marcados, caso os dois estejam ativos ao mesmo tempo)
        colecoesLiteraturaDisponiveis() {
            const mercados = this.mercadosSelecionados;
            const todas = mercados.flatMap(m => (this.literaturaCache[m] && this.literaturaCache[m].colecoes) || []);
            return [...new Set(todas)].sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },
        // Lista de Autores/Ilustradores de Literatura pro mercado já selecionado
        autoresLiteraturaDisponiveis() {
            const mercados = this.mercadosSelecionados;
            const todos = mercados.flatMap(m => (this.literaturaCache[m] && this.literaturaCache[m].autores) || []);
            return [...new Set(todos)].sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },

        // Carrega as Coleções (título) escopadas a Didáticos + um Segmento específico
        // (Ensino Fundamental I/II, e Educação Infantil/Público), sob demanda - uma vez por
        // combinação mercado+segmento, fica em cache depois. Só coleções que realmente pertencem
        // a Didáticos (o backend já aplica a mesma regra de exclusão usada no ReadAll).
       
        async getFiltrosDidaticosColecao(mercado, segmento) {
            const chave = `${mercado}|${segmento}`;
            if (this.didaticosColecaoCache[chave]) return; // já carregou essa combinação, não busca de novo
            try {
                const res = await http.get('Flipbook/GetFiltros', {
                    params: { categoria: 'Didáticos', rede: this.redeParaMercado(mercado), segmento },
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + this.token
                    }
                });
                // this.$set (não atribuição direta) - Vue 2 não rastreia a ADIÇÃO de uma chave nova
                // num objeto simples; sem isso, a lista só aparecia na tela se outra mudança
                // reativa qualquer forçasse um novo render depois da resposta chegar.
                this.$set(this.didaticosColecaoCache, chave, (res.data.colecoes || []).filter(c => !!c));
                this.$set(this.componentesDidaticosCache, chave, (res.data.disciplinas || []).filter(d => !!d));
            } catch (err) {
                console.log('Erro ao carregar Coleções de Didáticos', err);
                this.$set(this.didaticosColecaoCache, chave, []);
                this.$set(this.componentesDidaticosCache, chave, []);
            }
        },

        // Lista de Coleções de Didáticos pro Segmento+Mercado já carregado (vazio até a
        // primeira chamada de getFiltrosDidaticosColecao resolver)
        colecoesDidaticosDisponiveis(seg, mercado) {
            const chave = `${mercado}|${seg}`;
            let colecoes = (this.didaticosColecaoCache[chave] || []).slice();
            // "Assim eu Aprendo" pertence a Anos Iniciais (Ensino Fundamental I) - o backend só
            // exclui essa coleção quando o segmento pedido é exclusivamente Ensino Fundamental II,
            // então ela ainda vaza pra Educação Infantil (mesmo problema que já corrigimos na
            // ADMPortal pra Anos Finais - pedido pontual, sem livro vinculado de fato pra esse segmento).
            if (seg === 'Educação Infantil') {
                colecoes = colecoes.filter(c => ('' + c).toUpperCase().trim() !== 'ASSIM EU APRENDO');
            }
            return colecoes.sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },

       
        async getFiltrosDisciplinasEM() {
            if (this.disciplinasEMCache['EM']) return; // já carregou
            try {
                const res = await http.get('Flipbook/GetFiltros', {
                    params: {
                        categoria: 'Sistema de Ensino',
                        rede: this.redeParaMercado('privado'),
                        segmento: 'Ensino Médio'
                    },
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + this.token
                    }
                });
                this.$set(this.disciplinasEMCache, 'EM', (res.data.disciplinas || []).filter(d => !!d));
            } catch (err) {
                console.log('Erro ao carregar Disciplinas do Ensino Médio', err);
                this.$set(this.disciplinasEMCache, 'EM', []);
            }
        },

      
        mapaDisciplinasEM() {
            return {
                'Artes':               ['ARTES'],
                'Biologia':            ['BIOLOGIA'],
                'Ciências':            ['CIENCIAS', 'CIÊNCIAS'],
                'Educação Digital':    ['EDUCAÇÃO DIGITAL', 'EDUCACAO DIGITAL'],
                'Educação Física':     ['EDUCACAO FISICA', 'EDUCAÇÃO FÍSICA'],
                'Filosofia':           ['FILOSOFIA'],
                'Física':              ['FISICA', 'FÍSICA'],
                'Geografia':           ['GEOGRAFIA'],
                'História':            ['HISTORIA', 'HISTÓRIA'],
                'Língua Espanhola':    ['ESPANHOL'],
                'Língua Inglesa':      ['INGLES', 'INGLÊS'],
                'Língua Portuguesa':   ['PORTUGUES', 'PORTUGUÊS'],
                'Matemática':          ['MATEMATICA', 'MATEMÁTICA'],
                'Produção de Texto':   ['PRODUÇÃO DE TEXTO', 'PRODUCAO DE TEXTO'],
                'Projeto de Vida':     ['PROJETO DE VIDA'],
                'Química':             ['QUIMICA', 'QUÍMICA'],
                'Sociologia':          ['SOCIOLOGIA'],
                'Apostila':            ['APOSTILA'],
            };
        },

      
        disciplinasEMDisponiveis() {
            const brutas = this.disciplinasEMCache['EM'] || [];
            const mapa = this.mapaDisciplinasEM();
            const labels = new Set();
            const cobertas = new Set();
            for (const label in mapa) {
                if (mapa[label].some(v => brutas.includes(v))) {
                    labels.add(label);
                    mapa[label].forEach(v => cobertas.add(v));
                }
            }
            brutas.forEach(v => { if (!cobertas.has(v)) labels.add(v); });
           
            if (this.materiaisSelecionados.includes('Livro do Professor (EM)')) {
                labels.delete('INTEGRADO');
                labels.delete('Língua Inglesa');
                labels.delete('Ciências');
                labels.delete('Apostila');
            }
           
            if (this.materiaisSelecionados.includes('Livro do Aluno (EM)')) {
                const permitidasAluno = ['Língua Espanhola', 'Produção de Texto'];
                [...labels].forEach(label => { if (!permitidasAluno.includes(label)) labels.delete(label); });
            }
            return [...labels].sort((a, b) => a.localeCompare(b, 'pt-BR'));
        },

        // Dispara o carregamento das Disciplinas assim que o Segmento Ensino Médio é marcado.
        atualizarDisciplinasEM() {
            this.disciplinasEMSelecionadas = [];
            this.getFiltrosDisciplinasEM();
        },

        // Carrega a página solicitada (usa cache se disponível)
        async getLivros(pagina = 1) {
            this.loading = true;
            this.cards = [];
            this.paginasCache = {}; // limpa cache ao mudar filtros/busca

            // Token de requisição: invalida qualquer resposta antiga (de um filtro já trocado)
            // que chegue depois dessa - sem isso, trocar de filtro rápido podia fazer a resposta
            // de um filtro anterior sobrescrever o resultado certo do filtro atual.
            this.requestToken++;
            const tokenAtual = this.requestToken;

            try {
                const data = await this.fetchPagina(pagina);
                if (tokenAtual !== this.requestToken) return; // ficou obsoleto, descarta

                this.totalRegistros = data.totalRegistros;
                this.totalPaginas   = data.totalPaginas;
                this.paginaAtual    = data.paginaAtual;

                this.setLivrosCards(data.livros);
                this.setSuggestions(data.livros);

                // Pré-carrega as próximas páginas em segundo plano
                this.preCarregarProximasPaginas(pagina + 1, tokenAtual);

            } catch (err) {
                console.log(err);
                alert("Sua sessão expirou!");
                this.$router.push("/");
            } finally {
                if (tokenAtual === this.requestToken) this.loading = false;
            }
        },

        // Busca uma página da API ou retorna do cache
        async fetchPagina(pagina) {
            if (this.paginasCache[pagina]) {
                return this.paginasCache[pagina];
            }
            // Captura o token do filtro atual ANTES do await. Se o filtro trocar
            // durante a requisição (ex.: um preload em andamento de um filtro já
            // desmarcado), a resposta antiga NÃO pode entrar no cache do filtro novo
            // — senão a página passa a exibir livros de outro filtro (bug de
            // paginação ao desmarcar/remarcar e voltar pra mesma página).
            const tokenFiltro = this.requestToken;
            const res = await http.get(`Flipbook/GetAll?${this.buildParams(pagina)}`, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: "Bearer " + this.token
                }
            });
            if (tokenFiltro === this.requestToken) {
                this.paginasCache[pagina] = res.data;
            }
            return res.data;
        },

        // Pré-carrega as próximas páginas em segundo plano silenciosamente.
        // Recebe o token da requisição que a disparou - se outro filtro for aplicado nesse
        // meio tempo (token muda), para imediatamente e não escreve mais nada (cache/sugestões).
        async preCarregarProximasPaginas(paginaInicial, token) {
            this.carregandoMais = true;
            let pagina = paginaInicial;

            while (pagina <= this.totalPaginas) {
                if (token !== this.requestToken) break; // filtro trocou, descarta o resto
                if (this.paginasCache[pagina]) {
                    pagina++;
                    continue;
                }
                try {
                    await this.fetchPagina(pagina);
                    if (token !== this.requestToken) break; // trocou de filtro durante o fetch
                    // Alimenta sugestões de busca progressivamente
                    if (this.paginasCache[pagina]) {
                        this.setSuggestions(this.paginasCache[pagina].livros, true);
                    }
                    pagina++;
                } catch (err) {
                    console.log('Erro ao pré-carregar página', pagina, err);
                    break;
                }
            }
            if (token === this.requestToken) this.carregandoMais = false;
        },

       
        async onPaginaChange(pagina) {
            this.loading = true;
            this.cards = [];
            this.paginaRequestToken = (this.paginaRequestToken || 0) + 1;
            const tokenAtual = this.paginaRequestToken;
            try {
                const data = await this.fetchPagina(pagina);
                if (tokenAtual !== this.paginaRequestToken) return; // outra página já foi pedida depois - descarta
                this.paginaAtual = data.paginaAtual;
                this.setLivrosCards(data.livros);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (err) {
                console.log(err);
            } finally {
                if (tokenAtual === this.paginaRequestToken) this.loading = false;
            }
        },

        setLivrosCards(livros, append = false) {
            const novosCards = livros.map(livro => ({
                isbn:        livro.isbn,
                title:       livro.nome,
                src:         livro.capaURL,
                flex:        3,
                arquivo:     livro.flipbookURL,
                autor:       livro.autor,
                complemento: livro.complemento,
                rede:        livro.rede
            }));

            if (append) {
                this.cards = [...this.cards, ...novosCards];
            } else {
                this.cards = novosCards;
            }
        },

        setSuggestions(livros, append = false) {
            const novas = livros.map(livro => ({
                id:          livro.isbn,
                titulo:      livro.nome,
                seguimento:  livro.segmento,
                imagem:      livro.capaURL,
                arquivo:     livro.flipbookURL,
                complemento: livro.complemento,
            }));

            if (append) {
                this.suggestions[0].data = [...this.suggestions[0].data, ...novas];
            } else {
                this.suggestions[0].data = novas;
            }
        },

        setFiltros(livros) {
            livros.forEach(livro => {
                if (livro.materia && !this.disciplinas.includes(livro.materia))
                    this.disciplinas.push(livro.materia);
                if (livro.colecao && !this.colecoes.includes(livro.colecao))
                    this.colecoes.push(livro.colecao);
                if (livro.autor && !this.autores.includes(livro.autor))
                    this.autores.push(livro.autor);
            });

            this.disciplinas = [...this.disciplinas].sort();
            this.colecoes    = [...this.colecoes].sort();
            this.autores     = [...this.autores].sort();
        },

        // Quando o usuário muda um filtro — consulta API com filtros (debounced para evitar chamadas duplas)
        filterMaster() {
            
            if (this.query) {
                this.query = '';
                
                this.autosuggestKey++;
            }
            clearTimeout(this._filterDebounce);
            this._filterDebounce = setTimeout(() => {
                this.paginaAtual = 1;
                this.getLivros(1);
            }, 50);
        },

        // --- Navegação em cascata pela árvore de filtros (Nível 1 a 4) ---
        selecionarMercado(valor) {
            const idx = this.mercadosSelecionados.indexOf(valor);
            if (idx >= 0) this.mercadosSelecionados.splice(idx, 1);
            else this.mercadosSelecionados.push(valor);
          
            if (this.mercadosSelecionados.length === 0) {
                this.categoriasSelecionadas = [];
                this.segmentosSelecionados = [];
            this.gruposExpandidos = [];
                this.versoesSelecionadas = [];
                this.anoProgramaSelecionados = [];
                this.materiaisSelecionados = [];
                this.componentesSelecionados = [];
                this.apoioSelecionados = [];
                this.tiposPeriodoSelecionados = [];
                this.periodosSelecionados = [];
                this.modalidadesEMSelecionadas = [];
                this.seriesEMSelecionadas = [];
                this.disciplinasEMSelecionadas = [];
                this.materiaisLiteraturaSelecionados = [];
                this.colecoesDidaticosSelecionados = [];
                this.litAnoSerieSelecionados = [];
                this.litGeneroTextualSelecionados = [];
                this.litTemaSelecionados = [];
                this.litDataEspecialSelecionados = [];
                this.litPaginasSelecionados = [];
                this.litConteudosSelecionados = [];
                this.anosSelecionados = [];
            }
            this.filterMaster();
        },

        // Reseta tudo que está aninhado abaixo da Categoria (chamado seja qual for o caminho do clique)
        resetFiltrosAbaixoCategoria(cat, mercado) {
            this.segmentosSelecionados = [];
            this.gruposExpandidos = [];
            this.versoesSelecionadas = [];
            this.anoProgramaSelecionados = [];
            this.materiaisSelecionados = [];
            this.componentesSelecionados = [];
            this.apoioSelecionados = [];
            this.tiposPeriodoSelecionados = [];
            this.periodosSelecionados = [];
            this.modalidadesEMSelecionadas = [];
            this.seriesEMSelecionadas = [];
            this.disciplinasEMSelecionadas = [];
            this.materiaisLiteraturaSelecionados = [];
            this.colecoesDidaticosSelecionados = [];
            this.litAnoSerieSelecionados = [];
            this.litGeneroTextualSelecionados = [];
            this.litTemaSelecionados = [];
            this.litDataEspecialSelecionados = [];
            this.litPaginasSelecionados = [];
            this.litConteudosSelecionados = [];
            this.anosSelecionados = [];
            if (cat === 'Literatura' && this.categoriasSelecionadas.includes('Literatura')) {
                this.getFiltrosLiteratura(mercado);
            }
        },

        // Reseta tudo que está aninhado abaixo do Segmento (chamado seja qual for o caminho do clique)
        resetFiltrosAbaixoSegmento() {
            this.versoesSelecionadas = [];
            this.anoProgramaSelecionados = [];
            this.materiaisSelecionados = [];
            this.componentesSelecionados = [];
            this.apoioSelecionados = [];
            this.tiposPeriodoSelecionados = [];
            this.periodosSelecionados = [];
            this.modalidadesEMSelecionadas = [];
            this.seriesEMSelecionadas = [];
            this.disciplinasEMSelecionadas = [];
            this.materiaisLiteraturaSelecionados = [];
            this.colecoesDidaticosSelecionados = [];
            this.litAnoSerieSelecionados = [];
            this.litGeneroTextualSelecionados = [];
            this.litTemaSelecionados = [];
            this.litDataEspecialSelecionados = [];
            this.litPaginasSelecionados = [];
            this.litConteudosSelecionados = [];
            this.anosSelecionados = [];
        },

        // Nível 2 - Categoria: toggle multi-seleção (clique no texto da label)
        selecionarCategoria(valor, mercado) {
            const idx = this.categoriasSelecionadas.indexOf(valor);
            if (idx >= 0) this.categoriasSelecionadas.splice(idx, 1);
            else this.categoriasSelecionadas.push(valor);
            this.resetFiltrosAbaixoCategoria(valor, mercado);
        },

        // Nível 3 - Segmento: toggle multi-seleção (clique no texto da label)
        selecionarSegmento(valor, cat, mercado) {
            const idx = this.segmentosSelecionados.indexOf(valor);
            if (idx >= 0) this.segmentosSelecionados.splice(idx, 1);
            else this.segmentosSelecionados.push(valor);
            this.resetFiltrosAbaixoSegmento(valor, cat, mercado);
        },

        // Sub-filtro (Sistema de Ensino + Educação Infantil/EFI): Versão A/B - toggle multi-seleção
        selecionarVersao(valor) {
            const idx = this.versoesSelecionadas.indexOf(valor);
            if (idx >= 0) this.versoesSelecionadas.splice(idx, 1);
            else this.versoesSelecionadas.push(valor);
        },

        // Sub-filtro (Sistema de Ensino + Educação Infantil/EFI, Privado e Público): Ano de
        // Programa (2024/2026) - toggle multi-seleção
        selecionarAnoPrograma(valor) {
            const idx = this.anoProgramaSelecionados.indexOf(valor);
            if (idx >= 0) this.anoProgramaSelecionados.splice(idx, 1);
            else this.anoProgramaSelecionados.push(valor);
        },

        // Sub-filtro (Sistema de Ensino + EI, Área Pública): toggle do tipo Bimestre/Trimestre.
        // Marcar só o tipo (sem marcar nenhum período específico) já busca TODOS os períodos
        // dele - implementado no buildParams. Ao desmarcar o tipo, limpa os períodos específicos
        // que estavam marcados dentro dele (pra não ficar filtro "fantasma" sem aparecer na tela).
        selecionarTipoPeriodo(tipo) {
            const idx = this.tiposPeriodoSelecionados.indexOf(tipo);
            if (idx >= 0) {
                this.tiposPeriodoSelecionados.splice(idx, 1);
                this.periodosParaTipo(tipo).forEach(item => {
                    const pIdx = this.periodosSelecionados.indexOf(item.valor);
                    if (pIdx >= 0) this.periodosSelecionados.splice(pIdx, 1);
                });
            } else {
                this.tiposPeriodoSelecionados.push(tipo);
            }
        },

        // Lista de períodos específicos (1º a 4º Bimestre, ou 1º a 3º Trimestre)
        periodosParaTipo(tipo) {
            if (tipo === 'Bimestre') {
                return [
                    { label: '1º bimestre', valor: '1º Bimestre' },
                    { label: '2º bimestre', valor: '2º Bimestre' },
                    { label: '3º bimestre', valor: '3º Bimestre' },
                    { label: '4º bimestre', valor: '4º Bimestre' },
                ];
            }
            if (tipo === 'Trimestre') {
                return [
                    { label: '1º trimestre', valor: '1º Trimestre' },
                    { label: '2º trimestre', valor: '2º Trimestre' },
                    { label: '3º trimestre', valor: '3º Trimestre' },
                ];
            }
            return [];
        },

        // Sub-filtro (Sistema de Ensino + EI, Área Pública): período específico - toggle multi-seleção
        selecionarPeriodo(valor) {
            const idx = this.periodosSelecionados.indexOf(valor);
            if (idx >= 0) this.periodosSelecionados.splice(idx, 1);
            else this.periodosSelecionados.push(valor);
        },

        // Sub-filtro (Literatura): Materiais disponíveis - toggle multi-seleção. São coleções
        // reais (Literatura, Leiturativa, Letra e Cor etc.), não uma lista fixa hardcoded.
        selecionarMaterialLiteratura(valor) {
            const idx = this.materiaisLiteraturaSelecionados.indexOf(valor);
            if (idx >= 0) this.materiaisLiteraturaSelecionados.splice(idx, 1);
            else this.materiaisLiteraturaSelecionados.push(valor);
        },

        // Materiais disponíveis de Literatura pra esse Mercado + Segmento específico (coleções
        // reais que existem, vindas do cache escopado por GetFiltros)
        materiaisLiteraturaPara(mercado, seg) {
            const chave = `${mercado}|${seg}`;
            return (this.literaturaSegmentoCache[chave] && this.literaturaSegmentoCache[chave].materiais) || [];
        },

        // Sub-filtro (Sistema de Ensino + EI/EFI): Materiais disponíveis - toggle multi-seleção
        selecionarMaterial(valor) {
            const idx = this.materiaisSelecionados.indexOf(valor);
            if (idx >= 0) this.materiaisSelecionados.splice(idx, 1);
            else this.materiaisSelecionados.push(valor);
        },

        // Nível 4 - Ano: toggle multi-seleção (usado no clique na linha/label - o checkbox em si
        // já mexe no array sozinho via v-model, então NÃO pode chamar isso de novo, senão togla
        // duas vezes e cancela a mudança)
        selecionarAno(valor, cat, seg, mercado) {
            const idx = this.anosSelecionados.indexOf(valor);
            if (idx >= 0) this.anosSelecionados.splice(idx, 1);
            else this.anosSelecionados.push(valor);
            this.aposMudarAno(cat, seg, mercado);
        },

     
        aposMudarAno(cat, seg, mercado) {
            this.sincronizarSegmentoComAno(cat, seg, mercado);
            if (cat === 'Didáticos' && (seg === 'Ensino Fundamental I' || seg === 'Ensino Fundamental II' || seg === 'Educação Infantil' || (seg === 'Ensino Médio' && mercado === 'privado'))) {
                this.getFiltrosDidaticosColecao(mercado, seg);
            }
           
            if (cat === 'Didáticos' && !this.algumAnoSelecionadoEmDidaticos(mercado)) {
                this.componentesSelecionados = [];
                this.colecoesDidaticosSelecionados = [];
            }
        },

       
        sincronizarSegmentoComAno(cat, seg, mercado) {
            if (!cat || !seg || !this.segmentoComoTitulo(cat)) return;
            const aindaTemAnoDesseSegmento = this.anosParaExibir(cat, seg, mercado)
                .some(item => this.anosSelecionados.includes(item.valor));
            const segIdx = this.segmentosSelecionados.indexOf(seg);
            if (aindaTemAnoDesseSegmento && segIdx < 0) {
                this.segmentosSelecionados.push(seg);
            } else if (!aindaTemAnoDesseSegmento && segIdx >= 0) {
                this.segmentosSelecionados.splice(segIdx, 1);
            }
        },

        // Limpa toda a árvore de filtros de uma vez
        limparArvoreFiltros() {
            this.mercadosSelecionados = [];
            this.categoriasSelecionadas = [];
            this.segmentosSelecionados = [];
            this.gruposExpandidos = [];
            this.versoesSelecionadas = [];
            this.anoProgramaSelecionados = [];
            this.materiaisSelecionados = [];
            this.componentesSelecionados = [];
            this.apoioSelecionados = [];
            this.tiposPeriodoSelecionados = [];
            this.periodosSelecionados = [];
            this.modalidadesEMSelecionadas = [];
            this.seriesEMSelecionadas = [];
            this.disciplinasEMSelecionadas = [];
            this.materiaisLiteraturaSelecionados = [];
            this.colecoesDidaticosSelecionados = [];
            this.litAnoSerieSelecionados = [];
            this.litGeneroTextualSelecionados = [];
            this.litTemaSelecionados = [];
            this.litDataEspecialSelecionados = [];
            this.litPaginasSelecionados = [];
            this.litConteudosSelecionados = [];
            this.anosSelecionados = [];
            this.filterMaster();
        },

        filterDisciplina(value) {
            if (this.disciplinasAdicionadas.includes(value)) {
                this.disciplinasAdicionadas.splice(this.disciplinasAdicionadas.indexOf(value), 1);
            } else {
                this.disciplinasAdicionadas.push(value);
            }
            this.filterMaster();
        },

        filterColecao(value) {
            if (this.colecoesAdicionadas.includes(value)) {
                this.colecoesAdicionadas.splice(this.colecoesAdicionadas.indexOf(value), 1);
            } else {
                this.colecoesAdicionadas.push(value);
            }
            this.filterMaster();
        },

        filterAutor(value) {
            if (this.autoresAdicionados.includes(value)) {
                this.autoresAdicionados.splice(this.autoresAdicionados.indexOf(value), 1);
            } else {
                this.autoresAdicionados.push(value);
            }
            this.filterMaster();
        },

        
        usarDicaColecao(colecao) {
            this.query = colecao;
            // Força o vue-autosuggest a recriar do zero com o novo valor já no v-model -
            // setar a propriedade interna dele direto não sobrevive ao blur do campo
            // (ele reseta o texto exibido se não foi "selecionado" pelo fluxo oficial dele)
            this.autosuggestKey++;
            this.pesquisarNome();
        },

        // Busca por nome — chama a API com o texto digitado
        pesquisarNome() {
            this.paginaAtual = 1;
            this.getLivros(1);
            this.atualizarSugestoesRapido();
        },

        async atualizarSugestoesRapido() {
            if (!this.query || this.query.length < 3) return;
            const queryNoMomento = this.query; // captura pra comparar quando a resposta voltar
            try {
                const res = await http.get(`Flipbook/GetAll?${this.buildParams(1, 100)}`, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + this.token
                    }
                });
                if (queryNoMomento !== this.query) return; // o usuário já digitou outra coisa, descarta
                this.setSuggestions(res.data.livros, false);
            } catch (err) {
                console.log('Erro ao atualizar sugestões', err);
            }
        },

        limparFiltros() {
            this.mercadosSelecionados     = [];
            this.categoriasSelecionadas = [];
            this.segmentosSelecionados  = [];
            this.versoesSelecionadas    = [];
            this.anosSelecionados       = [];
            this.disciplinasAdicionadas = [];
            this.colecoesAdicionadas    = [];
            this.colecoesDidaticosSelecionados = [];
            this.autoresAdicionados     = [];
            this.query = '';
            this.filterMaster();
        },

        onInputChange() {
            clearTimeout(this.debounceTimer);

            if (!this.query || this.query.length === 0) {
                this.pesquisarNome();
                return;
            }

            if (this.query.length < 3) return;

            // Aguarda 500ms após o usuário parar de digitar
            this.debounceTimer = setTimeout(() => {
                this.pesquisarNome();
            }, 500);
        },

        onKeyDown(e) {
            if (e.key === 'Enter' && this.query.length >= 3) {
                this.pesquisarNome();
            }
        },

        async setLogFlipbook(isbn, complemento) {
            http.put("Flipbook/LogAcessoFlipbook", { isbn, complemento }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + this.token
                }
            });
        },

        async abrirFlipbook(url, isbn, complemento) {
            const storageGT = JSON.parse(localStorage.getItem("GT"));
            this.gtToken   = storageGT.token;
            this.gtCodUser = storageGT.user_id;

            generateTokenAPI.post(`GenerateGuid/Create`,
                { user_Id: this.gtCodUser },
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.gtToken
                    }
                })
                .then(res => {
                    let params = `?guid=${res.data.guid}&token=${this.gtToken}`;
                    let routeData = this.$router.resolve({
                        name: "flippingbook",
                        query: { id: url + params }
                    });
                    window.open(routeData.href, "_blank");
                    this.setLogFlipbook(isbn, complemento);
                })
                .catch(err => {
                    console.log(err);
                    alert("Sua sessão expirou!");
                    this.$router.push("/");
                });
        },

        async Visualizacao(url, id, complemento) {
            $("#v-video").fadeOut();

            http.post('Flipbook/BuscarInformacoesFlipbook?Isbn=' + id + '&complemento=' + complemento, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Authorization": "Bearer " + this.token
                }
            }).then(res => {
                this.informacoes = res.data;

                $("#livroid").attr('src', res.data.imagemCapa);
                $("#InNome").html(res.data.nomeTitulo);
                $("#infISBN").html('<strong>ISBN: </strong>' + res.data.isbn);
                $("#infDescricao").html(res.data.resumo);
                $("#infPagina").html(res.data.paginas);
                $("#infFormato").html(res.data.formato);
                $("#infAno").html(res.data.ano);
                $("#InAutor").html('Autor(es): ' + res.data.autorNomeCapa);
                $("#InSegmento").html('Segmento: ' + res.data.segmento);
                $("#infDisciplina").html(res.data.disciplina);

                if (res.data.link != 'Sem vídeo' && res.data.link != '') {
                    let codV;
                    if (res.data.link.indexOf('watch') > -1) {
                        codV = res.data.link.split('watch?v=')[1];
                        if (res.data.link.indexOf('&') > -1) codV = codV.split('&')[0];
                    } else {
                        codV = res.data.link.split('https://youtu.be/')[1];
                    }
                    let AuxV = `<iframe width="100%" height="315" src="https://www.youtube.com/embed/${codV}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
                    $("#link-video").html(AuxV);
                    $("#v-video").fadeIn();
                } else {
                    $("#v-video").fadeOut();
                }

                localStorage.setItem("aux", 1);

                if (res.data.isbn == null) {
                    this.dialog = false;
                    this.dialogerror = true;
                } else {
                    this.dialog = true;
                    this.dialogerror = false;
                }
            }).catch(err => {
                console.log(err);
                alert("Sua sessão expirou!");
                this.$router.push("/");
            });

            if (localStorage.getItem("aux") == 1) {
                this.dialog = true;
                this.dialogerror = false;
            } else {
                this.dialog = false;
                this.dialogerror = true;
            }
        },

        normalizar(texto) {
            if (!texto) return '';
            return texto.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        },

        highlightTexto(texto) {
            if (!this.query || this.query.length < 3) return texto;
            const qNorm = this.normalizar(this.query);
            const textoNorm = this.normalizar(texto);
            const idx = textoNorm.indexOf(qNorm);
            if (idx === -1) return texto;
            return (
                texto.substring(0, idx) +
                '<mark class="autosuggest-highlight">' +
                texto.substring(idx, idx + this.query.length) +
                '</mark>' +
                texto.substring(idx + this.query.length)
            );
        },

        onSelected(item) {
            if (item && item.item && (item.item.tipo === 'colecao-grupo' || item.item.tipo === 'colecao')) {
                return; // os chips individuais (@click.stop) já tratam a ação sozinhos
            }
            this.selected = item.item;
        },

        getSuggestionValue(suggestion) {
            return suggestion.item.name;
        },

        focusMe() {}
    }
};
</script>

<style lang="scss">
@use "../css/style.scss";

section.banner-catalogo {
    background-image: url("../assets/bg-catalogo.png");
    height: 100vh;
    max-height: 486px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    @media only screen and (max-width: 600px) {
        max-height: 286px;
    }
}

.busca {
    background: #19286e;

    @media only screen and (max-width: 959.99px) {
        margin: 104px 0 0 0;
        background: none !important;
    }

    .campo-de-busca {
        background: white;
        width: 100%;
        max-width: 500px;
        margin: 0 24px;

        @media only screen and (max-width: 959.99px) {
            max-width: auto;
            margin: 0;
            border: 1px solid #19286e;
        }
    }

    .autosuggest-dicas-grupo {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px;
        padding: 0.75rem 0.75rem 0.75rem 0.75rem;
        font-size: 0.8rem;
        border-bottom: 1px solid #eee;
    }
    .autosuggest-dicas-label {
        color: #6b7280;
        margin-right: 2px;
    }
    .autosuggest-dica-chip {
        background: #eef1fb;
        color: #19286e;
        border-radius: 14px;
        padding: 3px 12px;
        cursor: pointer;
        font-weight: 600;
        transition: background 0.15s ease;
    }
    .autosuggest-dica-chip:hover {
        background: #d8deF5;
    }

    input { width: 100%; padding: 0.5rem; border: 0 !important; }

    ul { width: 100%; color: rgba(30, 39, 46, 1); list-style: none; margin: 0; padding: 0.5rem 0 0.5rem 0; }

    li { margin: 0; padding: 0.75rem 0 0.75rem 0.75rem; display: flex; align-items: center; }
    li:hover { cursor: pointer; }

    .autosuggest-container { display: flex; justify-content: center; }
    :focus { outline: -webkit-focus-ring-color auto 0 !important; }
    #autosuggest { width: 100%; display: block; }

    .autosuggest__results-item--highlighted { background-color: #f0f4ff; }
    .autosuggest__results-container {
        background: white; width: 100%; max-width: 500px; max-height: 400px;
        overflow-y: auto; overflow-x: hidden; position: absolute; z-index: 9;
        border-radius: 0 0 8px 8px; box-shadow: 0px 8px 24px 0px rgba(0,0,0,0.15);
    }

    .autosuggest-item { display: flex; align-items: center; gap: 12px; padding: 4px 0; }
    .autosuggest-capa { width: 32px; height: 44px; object-fit: cover; border-radius: 2px; flex-shrink: 0; background: #eee; }
    .autosuggest-info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
    .autosuggest-titulo { font-size: 13px; font-weight: 600; color: #19286e; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .autosuggest-segmento { font-size: 11px; color: #888; }
    .autosuggest-highlight { background: #fff59d; color: #19286e; font-weight: 700; border-radius: 2px; padding: 0 1px; }
}

.filtro {
    &.v-card { border-radius: 0; }
    .title { background: #eee; }
    .v-list-item__title { padding: 8px 16px; color: #19286e; }
    .v-expansion-panel::before { box-shadow: none; }
    .v-expansion-panel-header { min-height: initial; padding: 16px; color: #19286e; }
    .v-list-item { padding: 0; }
    .v-input--selection-controls { margin-top: 0; padding-top: 4px; }
    .v-label { font-size: 13px; }
    .v-messages { display: none; }

    &.filtro-mobile {
        height: 95vh;
        .v-item-group { overflow-x: auto !important; height: calc(95vh - 76px); padding-bottom: 16px; }
    }
}

.btn-filtrar { &.v-btn, .v-icon { color: #19286e; } }
.btn-fechar-filtro { position: absolute; top: 12px; right: 16px; }

.grid {
    &>.col, &>[class*="col-"] { padding: 0 !important; }
    .flex { padding: 0 0 16px 0 !important; }
    .v-image__image--cover { background-size: contain; }
    a { text-decoration: none; }

    .v-card {
        border-radius: 0;
        .v-card__title { color: #19286e; font-size: 1rem; font-weight: 600; letter-spacing: 0.0125em; line-height: 1.2rem; padding: 8px 16px; word-break: initial; }
        .v-card__actions { width: 100%; padding: 0; position: absolute; bottom: 0; }
        .v-btn { background-color: #93c83d !important; color: #19286e; }
        &.elevation-2 { box-shadow: none !important; }
    }

    .v-pagination__item, .v-pagination__navigation { box-shadow: none; }
    .v-pagination__item:focus, .v-pagination__navigation:focus { outline: -webkit-focus-ring-color auto 0; }
    .layout:only-child { margin: 0 !important; }
}

.float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: 20px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50%;
    text-align: center;
    z-index: 9999;
    overflow: visible;
}

.my-float {
    width: 60px;
    height: 60px;
    display: block;
}

/* Robô exibido acima do botão do WhatsApp */
.robo-aj {
    position: absolute;
    width: 90px;
    height: auto;
    max-width: none;
    bottom: 48px;
    right: -15px;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: none;
    z-index: 10000;
}

/* Árvore de filtros em cascata (Mercado > Categoria > Segmento > Ano) */
.filtro-section-header {
    font-weight: 600;
    color: #19286e;
    font-size: 0.95rem;
}
.filtro-checkbox-row {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 2px 0;
    font-size: 0.875rem;
    color: #19286e;
}
.filtro-checkbox-row .filtro-checkbox {
    flex: 0 0 auto;
    margin: 0;
    padding: 0;
}
.filtro-checkbox-row .filtro-checkbox .v-input__control {
    flex-grow: 0;
}
.filtro-checkbox-row .v-input--selection-controls__input {
    margin-right: 6px;
}
.filtro-checkbox-row span {
    line-height: 1.3rem;
}
.filtro-label-ativo {
    color: #19286e !important;
    font-weight: 600;
}

/* Padding geral da árvore dentro do card */
.filtro-mercado-item {
    padding: 0 16px;
}
.filtro-nivel-bloco {
    margin-top: 2px;
}

/* Indentação progressiva por nível */
.filtro-nivel-1 { padding-left: 0; font-weight: 600; }
.filtro-nivel-2 { padding-left: 16px; }
.filtro-nivel-3 { padding-left: 32px; }
.filtro-nivel-4 { padding-left: 48px; }

/* Título de agrupamento dentro da árvore (ex: "Escolha a idade", "Materiais disponíveis") */
.filtro-titulo-grupo {
    padding-left: 48px;
    margin-top: 10px;
    font-weight: 600;
    font-size: 0.85rem;
    color: #19286e;
}

/* Segmento exibido como título (dentro de Didáticos/Apoio) */
.filtro-segmento-titulo {
    margin-top: 12px;
    font-weight: 700;
    color: #19286e;
}

.filtro-segmento-titulo-clicavel {
    cursor: pointer;
    display: flex;
    align-items: center;
    user-select: none;
}

.filtro-seta-expandir {
    margin-right: 4px;
    color: #19286e !important;
}


.filtro-titulo-grupo-clicavel {
    cursor: pointer;
    display: flex;
    align-items: center;
    user-select: none;
}

.filtro-titulo-grupo {
    font-weight: 700;
    font-size: 15px !important;
}

.filtro-titulo-grupo {
    padding-left: 32px;
    font-size: 15px;
}

.v-input__slot {
    margin-top: 3px;
    margin-bottom: 4px !important;
}
.filtro-checkbox-row{
        color: #696969; 
}

.flex-direction-column{
    flex-direction: column;
    display: flex !important;
    align-content: space-around;
}
.pad-t-10{
padding-top:10px;
}

.box-conteudo-lag .filtro.theme--light.v-card{
        padding-bottom: 20px !important;
}

.filtro-checkbox-row.filtro-nivel-1 span{
    color: #19286e;
    font-size: 16px;
    font-weight: 800;
    margin-top: 3px;
}

.filtro-checkbox-row:hover span{
    color:#92D401 !important
}

.filtro-checkbox-row span {
    line-height: 18px;
}

.filtro-titulo-grupo {
    font-weight: 700;
    font-size: 14px;
}

.busca-autor .v-select__slot{
    background-color: rgba(243, 243, 243, 0.3215686275);
    border: 1px #ccc solid;
    padding: 8px;
    border-radius: 5px;
    color: #858585;
    margin-top: -8px;
    margin-bottom: 10px;
}

@media (max-width: 600px) {
    .filtro.theme--light.v-card {
        margin-top: 15px;
        border: transparent;
    }
}

</style> 